export const translationUk = {
  '<all users>': '<всі користувачі>',
  '24 hours': '24 години',
  '30 days': '30 днів',
  '7 days': '7 днів',
  Account: 'Обліковий запис',
  'Accounting for battery replacement': 'Облік заміни АКБ',
  'Accounting unit': 'Одиниця обліку',
  'Access Rights': 'Права',
  'Access to document verification': 'Доступ до перевірки документів',
  'Access to checking extended registration documents is allowed. After the time has expired, the password must be re-entered to reset the timer and continue testing.':
    'Доступ до перевірки документів розширеної реєстрації дозволено. Після закінчення часу скидання таймера та продовження перевірки необхідно ввести пароль повторно.',
  'Around the clock': 'Цілодобово',
  Acquirer: 'Еквайєр',
  'Acquirer Id': 'Ідентифікатор Набувача',
  Acquirers: 'Еквайринг',
  Activation: 'Активація',
  'Activation conditions': 'Умови активації',
  Action: 'Дія',
  Actions: 'Дії',
  Analytics: 'Аналітика',
  Author: 'Автор',
  'Active order': 'В оренді',
  'Automatic debits': 'Автоматичні списання',
  'Altitude above sea level': 'Висота над рівнем моря',
  Inactive: 'Неактивні',
  'Active trip': 'Активна поїздка',
  'Active subscription': 'Активний абонемент',
  'Active subscriptions': 'Активні абонементи',
  'Activity time': 'Час активності',
  'Activity log': 'Журнал дій',
  'Activity level': 'Рівень активності',
  Activate: 'Активувати',
  Deactivate: 'Деактивувати',
  'Activate if necessary to specify the color of the object': 'Активуйте, якщо необхідно вказати колір об\'єкта',
  'Activate to provide access to the functionality of creating and editing rates.':
    'Активуйте, щоб надати доступ до функціоналу створення та редагування тарифів',
  'Activate if you want the first rate in the list of available rates for the unit to be selected by default.':
    'Активуйте, якщо ви хочете, щоб перший тариф у списку доступних тарифів об\'єкту був обраний за замовчуванням',
  'Active bank card': 'Активна банківська картка',
  'Mobile application and its version': 'Мобільний додаток та його версія',
  Add: 'Додати',
  'Add more': 'Додати ще',
  'Add Geopoint': 'Додати геоточку',
  'Add action': 'Додати дію',
  'Add comment': 'Додати коментар',
  'Add condition': 'Додати умову',
  'Ad cover': 'Обкладинка оголошення',
  'Add document': 'Додати документ',
  'Add geofence': 'Додати геозону',
  'Add price plan': 'Додати тариф',
  'Add language': 'Додати мову',
  'Add point': 'Додати точку',
  'Add image': 'Додати фото',
  'Add video': 'Додати відео',
  'Add part': 'Додати частину',
  'Add event': 'Додати подію',
  'Add translates': 'Додати переклади',
  'Add translate': 'Додати переклад',
  'Add to group': 'Додати до групи',
  'Add working days': 'Додати робочі дні',
  'Add time period': 'Додати період часу',
  Address: 'Адреса',
  'Additional Information': 'Додаткова інформація',
  'Additional information about the tariff, including information about the debiting of funds and conditions.':
    'Додаткова інформація про тариф, який включає інформацію про списання грошових коштів та умов.',
  'Add the document content, including data substitution patterns.': 'Додайте зміст документа, включно з шаблонами підставлення даних.',
  Admin: 'Адмін',
  Administrator: 'Адміністратор',
  Manager: 'Менеджер',
  'Admin login': 'Логін адміністратора',
  'Alarm retranslator': 'Ретранслятор тривог',
  'Are you sure?': 'Ви впевнені?',
  'Arbitrary command': 'Довільна команда',
  Retranslator: 'Ретранслятор',
  'Alarming notification': 'Тривожне повідомлення',
  'Alarm notifications': 'Тривожні повідомлення',
  Alarms: 'Тривоги',
  All: 'Все',
  'All-time statistics': 'За весь час',
  Amount: 'Сума',
  Allowed: 'Дозволено',
  'Amount in coin': 'Сума в монетах',
  'Amount in currency': 'Сума в валюті',
  'Amount owed': 'Сума заборгованості',
  'Api Key': 'Ключ API',
  Appointments: 'Призначення',
  Assignments: 'Призначення',
  Assignment: 'Призначення',
  'Appointment date': 'Дата призначення',
  Apply: 'Застосувати',
  'App version': 'Версія',
  'Are sure you want to delete this item': 'Ви впевнені, що хочете видалити цей елемент',
  'Are you sure you wish to send push notifications to all clients of this project':
    'Ви впевнені, що хочете надіслати push-повідомлення всім клієнтам проекту',
  'Assigned to': 'Призначена на',
  'Assign a bag': 'Призначити сумку',
  'Assigned to groups': 'Призначений на групи',
  'Unit has been added to group': 'Об\'єкт додано до групи',
  'Read-only access': 'Доступ із правами "тільки читання"',
  'Select users': 'Виберіть користувачів',
  'Are you sure you want to remove unit from this group?': 'Чи дійсно прибрати об\'єкт із групи?',
  'At least one element must be added': 'Повинен бути доданий хоча б один елемент',
  'At least one notification type must be selected': 'Повинен бути обраний хоча б один тип повідомлення',
  'At least two items must be selected': 'Необхідно обрати як мінімум дві послуги',
  'At least one field must be filled in': 'Необхідно заповнити хоча б одне поле',
  'At least one option must be selected': 'Потрібно вибрати принаймні один варіант',
  Audio: 'Аудіо',
  'Authentication method': 'Способ аутентифікації',
  'Availability in application': 'Доступність в додатку',
  Availability: 'Доступність',
  'in application': 'в додатку',
  Initiator: 'Ініціатор',
  'Order completion initiator': 'Ініціатор завершення замовлення',
  'Order cancellation initiator': 'Ініціатор скасування замовлення',
  'Avail.': 'Дост.',
  Available: 'Доступний',
  Accessible: 'Mövcuddur',
  'Available time': 'Доступний час',
  'Available units': 'Доступні об\'єкти',
  'Active objects': 'Активні об\'єкти',
  'Not available': 'Знятий з доступу',
  'On charge': 'На зарядці',
  'At warehouse': 'На складі',
  'Attached to unit': 'Підключено до об\'єкту',
  'Attached tracker': 'Підключений трекер',
  'Under repair': 'В ремонті',
  'Unpaid orders': 'Неоплачені замовлення',
  'Unpaid fines': 'Несплачені штрафи',
  'Availability schedule': 'Розклад доступності',
  'Average cost': 'Середня вартість',
  Average: 'Середня',
  'Average distance': 'Середня відстань',
  'Average duration': 'Середня тривалість',
  'Awaiting confirmation': 'Очікування підтвердження',
  Awaiting: 'Очікування',
  'A new refund operation will be created in the related operations if you try again.': 'При повторній спробі у зв\'язаних операціях буде створено нову операцію повернення.',
  Attention: 'Увага',
  'A short description of the subscription is displayed in the list of subscriptions in the Subscription catalog section in the mobile application':
    'Короткий опис абонементу відображається в списку абонементів розділу Каталог абонементів у мобільному додатку',
  'A detailed description of the subscription is displayed in the subscription card in the mobile application':
    'Детальний опис абонементу відображається в картці абонементу в мобільному додатку',
  'A document can be added either by adding text to the fill-in field or by uploading a file containing the document text.': 'Документ можна додати як шляхом введення тексту в поле заповнення, так і за допомогою завантаження файлу, що містить текст документа.',
  After: 'Через',
  'Baby carriages': 'Візки',
  'Baby carriage': 'Візок',
  'Baby carriage price': 'Ціна візка',
  Balance: 'Баланс',
  Bags: 'Сумки',
  'Bag number': 'Номер сумки',
  'List of bag numbers': 'Список номерів сумок',
  'Balance AuthCall': 'Баланс AuthCall',
  'Balance History': 'Історія балансу',
  'Balance packages': 'Бонусні пакети',
  'Balance replenishment': 'Поповнення балансу',
  'Balance replenishment in currency': 'Поповнення балансу в валюті',
  'Balance 2023': 'Баланс 2023',
  'Top-up balance 2023': 'Поповнити баланс 2023',
  'Top-up': 'Поповнити',
  'Top-up of personal account balance': 'Поповнення балансу особового рахунку',
  'User balance 2023': 'Баланс користувача 2023',
  Batteries: 'Батареї',
  'Battery charge': 'Заряд батареї',
  'Battery charge calculation settings': 'Налаштування обчислення заряду АКБ',
  'Battery lock: no information': 'Замок батареї: немає інформації',
  'Battery lock: Closed': 'Замок батареї: Закритий',
  'Battery lock: Open': 'Замок батареї: Відкритий',
  'Battery mount type': 'Тип розміщення АКБ',
  'Battery before replacement': 'Батарея до заміни',
  'Battery after replacement': 'Батарея після заміни',
  'Battery: Attached to unit': 'Підключена до об\'єкта',
  'Branch offices': 'Філії',
  'Branch office': 'Філія',
  'Select a project for battery.': 'Виберіть проект, у якому створюється батарея.',
  'Select a project for the hardware model you are creating': 'Виберіть проєкт, у якому створюється модель обладнання',
  'Select a project for the document you are creating': 'Виберіть проєкт, у якому створюється документ',
  'Select a country for the document you are creating': 'Виберіть країну, для якої створюється документ',
  'Select a business model for the document you are creating': 'Виберіть бізнес-модель, для якої створюється документ',
  'Select a unit type for the document you are creating': 'Виберіть тип об’єкта, для якого створюється документ',
  'Select a project for the region you are creating': 'Виберіть проєкт, у якому створюється регіон',
  'Select a project for the geofence you are creating': 'Виберіть проєкт, у якому створюється геозона',
  'Select a project for the geopoint you are creating': 'Виберіть проєкт, у якому створюється геоточка.',
  'Select a project for the icon you are creating': 'Виберіть проєкт, у якому створюється іконка.',
  'Select the project country for the geofence you are creating': 'Виберіть країну проєкту, у якій створюється геозона',
  'Select the project country for the geopoint you are creating': 'Виберіть країну проєкту, у якій створюється геоточка.',
  'Select the country region for the geofence you are creating': 'Виберіть регіон країни, у якому створюється геозона',
  'Select the project country for the region you are creating': 'Виберіть країну проєкту, у якій створюється регіон',
  'Select the project country in which battery will be used.': 'Виберіть країну проекту, де буде використовуватися батарея.',
  'Select the country region for the geopoint you are creating': 'Виберіть регіон країни, у якому створюється геоточка.',
  'Select the business-model for the geopoint you are creating': 'Виберіть бізнес-модель, для якої створюється геоточка.',
  'Specify the owner of the battery.': 'Вкажіть власника батареї.',
  'Assign battery to the region in which it will be used.': 'Призначте батарею на регіон, де він буде експлуатуватися.',
  'Enter the battery name.': 'Введіть назву батареї.',
  'Registration number must match the number specified in the battery name. Based on the specified registration number, the system generates a QR code required to assign the battery to the unit. Registration number is entered manually to assign the battery if it\'s impossible to scan the QR code.':
  'Реєстраційний номер повинен відповідати вказаному номеру в назві батареї. На підставі зазначеного реєстраційного номера системою генерується QR-код, необхідний призначення батареї на об\'єкт. Якщо QR-код з якоїсь причини не зчитується, для призначення батареї введення реєстраційного номера здійснюється вручну.',
  'Provide the battery serial number.': 'Вкажіть серійний номер батареї.',
  'If the battery is already installed, select the unit. Otherwise, leave the field blank.':
  'Якщо батарею вже встановлено, виберіть об\'єкт.',
  'Activate if there is a tracker installed in the battery.': 'Активуйте, якщо в батареї встановлено трекер.',
  'If tracker has already been added to the system earlier, to be able to assign the tracker, select the "Select existing" option. To add a new tracker to the system with automatic assignment to the battery, select the "Add new" option.':
  'Якщо трекер уже був доданий до системи раніше, для отримання можливості призначити трекер виберіть "Вибрати існуючий". Щоб додати новий трекер до системи з автоматичним призначенням на батарею, виберіть "Створити новий".',
  'Select a tracker to assign to the battery.': 'Виберіть трекер для батареї.',
  'Enter the tracker name.': 'Введіть назву трекера.',
  'Select the tracker model.': 'Виберіть модель трекера.',
  'Specify the model of telematics equipment installed. Depending on the selected model, the correct operation of message reception, sending commands and functional features of the equipment depends on it.':
  'Вкажіть модель телематичного обладнання, встановленого у вашому об\'єкті. Залежно від вибраної моделі обладнання залежить коректність прийому повідомлень, відправки команд і функціональних особливостей обладнання.',
  'Specify the IMEI of the telematics equipment installed. Equipment communication with the server depends on the correctness of the specified IMEI. It is recommended to check the correctness of the entered data several times.':
  'Вкажіть IMEI телематичного обладнання, встановленого у вашому об\'єкті. Від коректності зазначеного IMEI залежить зв\'язок обладнання із сервером. Рекомендується кілька разів перевірити коректність даних.',
  'Enter the number of the SIM card installed in the telematics equipment.': 'Вкажіть номер SIM-картки, встановлений у телематичному обладнанні.',
  'Choose tracker': 'Виберіть трекер',
  'Enter SIM number': 'Введіть номер SIM',
  'Enter the serial number' : 'Введіть серийный номер',
  'Enter the courier UID' : 'Введіть UID кур\'єра',
  'Add device': 'Додати пристрій',
  'Enter serial number of device': 'Введіть серійний номер пристрою',
  'Device successfully added': 'Пристрій успішно додано',
  Devices: 'Пристрої',
  'Co-owned devices': 'Співвласник пристроїв',
  'Are you sure you want to remove selected device from the courier?': 'Ви впевнені, що хочете видалити вибраний пристрій у кур\'єра?',
  'Assign device': 'Призначити пристрій',
  'Purchases of devices': 'Покупки пристроїв',
  'Purchase information': 'Відомості про покупку',
  'Enter tracking number (optional)': 'Введіть трек-номер (необов\'язково)',
  'For couriers': 'Для кур\'єрів',
  'For QR sharing': 'Для QR-шерингу',
  'Price plans for couriers': 'Тарифи для кур\'єрів',
  'Price plans for qr sharing': 'Тарифи для QR-шерингу',
  'Internal name (for admin panel)': 'Внутрішнє ім\'я (для адмін-панелі)',
  'Internal name': 'Внутрішня назва',
  'Payment in advance ... days before the start of the next subscription period':
'Оплата заздалегідь за ... днів до початку наступного періоду передплати',
  'Duration of subscription period, days': 'Тривалість періоду передплати, днів',
  'Duration, days': 'Тривалість, днів',
  'Price plan group': 'Група тарифів',
  'Group of price plans': 'Група тарифів',
  'Groups of price plans for couriers': 'Групи тарифів для кур\'єрів',
  'Auto-renewal': 'Автоподовження',
  Billing: 'Біллінг',
  'Action on payment failure': 'Дія при несплаті',
  'Start subscription automatically when unit becomes online': 'Починати білінг автоматично, коли пристрій вийде на зв\'язок',
  'Default price plan': 'Тариф за замовчуванням',
  'Price plan in case of payment failure': 'Фіксований тариф у разі несплати',
  'Billing interval type': 'Тип інтервалу тарифікації',
  'Number of full free of charge intervals': 'Кількість безкоштовних повних інтервалів',
  Title: 'Назва',
  'First partial month is free of charge': 'Перший неповний місяць надається безкоштовно',
  'Do not make payments for the next period and suspend service if unit is offline':
    'Не проводити платежі за наступний період та призупинити обслуговування, якщо об\'єкт не на зв\'язку',
  'Days between last message from the unit and next interval': 'Кількість днів між останнім повідомленням і початком наступного інтервалу',
  'Resume service and payments if unit is back online': 'Продовжити обслуговування та платежі, якщо об\'єкт повернувся на зв\'язок',
  'Maximum allowed debt before cancelling service': 'Максимальна заборгованість перед припиненням обслуговування',
  'Unit owner': 'Власник об\'єктів',
  'executor-subscription': 'Підписка',
  'executor-subscriptions': 'Підписки',
  'executor-has-subscriptions': 'Має підписки',
  Intervals: 'Інтервали',
  'Service active until': 'Обслуговування активно до',
  'executor-unit-service': 'Обслуговування',
  'Default price plan group for couriers': 'Група кур\'єрських тарифів за замовчуванням',
  'Managing of courier price plans': 'Створення тарифів та груп тарифів для кур\'єрів',
  'Allow couriers to operate without subscriptions': 'Кур\'єри працюють без підписки',
  default: 'за замовчуванням',
  'Service is active': 'Обслуговування активно',
  'Blocked from': 'Дата блокування',
  'Reason of blocking': 'Причина блокування',
  'Price plan group of the next interval': 'Група тарифів для наступного інтервалу',
  'Price plan of the next interval': 'Тариф для наступного інтервалу',
  'Date of next payment': 'Дата наступного платежу',
  Modify: 'Змінити',
  Device: 'Пристрій',
  'Installed tracker': 'Встановлений трекер',
  'Presence in the system': 'Наявність в системі',
  'Select a hardware model': 'Виберіть модель обладнання',
  'Select unit': 'Виберіть об\'єкт',
  'Tracker attached': 'Встановлен трекер',
  'Change battery charge calculation method': 'Змінити метод обчислення заряду АКБ',
  'Name of charge parameter': 'Назва параметра',
  'Parameter value when charge is 0%': 'Значення параметра за заряду АКБ 0%',
  'Parameter value when charge is 100%': 'Значення параметра за заряду АКБ 100%',
  'Battery registration status in the system': 'Статус реєстрації батареї в системі',
  'Actions on start of the trip': 'Дії при старті подорожі',
  'Actions minutes before finish of the trip': 'Дії за кілька хвилин до завершення поїздки',
  'Time before finish of the trip': 'Час перед завершенням подорожі',
  'Actions on finish of the trip': 'Дії після завершення поїздки',
  'Actions on leaving ride allow area': 'Дії під час виїзду за межі зони, дозволеної для катання',
  'Actions on entering ride allow area': 'Дії при поверненні до зони, дозволеної для катання',
  'Execute actions minutes before finish of the trip': 'Виконати дії за кілька хвилин до завершення поїздки',
  'Number of minutes before finish of the trip': 'Хвилин до завершення поїздки',
  'Anonymous client': 'Анонімний клієнт',
  'Duration, minutes': 'Тривалість, хвилин',
  'Action not selected': 'Дія не обрана',
  'Birth date': 'Дата народження',
  'Billing model': 'Порядок оплати',
  'Billing period': 'Розрахунковий період',
  'Business model': 'Бізнес-модель',
  'Business models': 'Бізнес-моделі',
  'All projects': 'Усі проекти',
  'All business models': 'Усі бізнес-моделі',
  'Insufficient funds to continue service': 'Недостатньо грошових коштів для продовження обслуговування',
  'out of': 'з',
  'Old billing': 'Старий білінг',
  'of your units were hidden and not available for rent to clients': 'ваших об\'єктів були приховані та недоступні для оренди клієнтам',
  'To resume service, you need to top up the balance': 'Для відновлення обслуговування необхідно поповнити баланс',
  'If you have any questions, please contact your manager': 'У разі виникнення запитань зверніться до Вашого менеджера',
  'To ensure that push notification text displays on all screens (including small smartphones), it\'s recommended to limit it to 60-80 characters, including spaces.': 'Для гарантованого відображення тексту пуш-сповіщення на будь-яких екранах (включно з невеликими смартфонами) рекомендується вкладатися в 60–80 символів із пробілами.',
  'If tracker is connected to a removable battery, select the "Removable battery" connection method. If tracker is connected to unit with a non-removable battery, select the "Unit" connection method.':
   'Якщо трекер підключається до знімної АКБ, виберіть метод підключення "Знімний АКБ". Якщо трекер підключається до об\'єкта з незнімним АКБ, виберіть метод підключення "Об\'єкти".',
  'Is paid': 'Оплачено',
  'Created at': 'Дата створення',
  'Paid at': 'Дата оплати',
  'Paid orders': 'Оплачені замовлення',
  'Operation type': 'Тип операції',
  'Amount in payment currency': 'Сума у валюті оплати',
  'Accounting period': 'Розрахунковий період',
  'Bicycle price': 'Ціна велосипеду',
  'Bicycle car price': 'Ціна веломобіля',
  'Blink lights': 'Блимнути світлом',
  Facilities: 'Зручності',
  'From last': 'Від останньої',
  'From first': 'Від першої',
  Finance: 'Фінанси',
  'Being in a parking area': 'Перебування в зоні паркування',
  'Being in the riding area': 'Перебування в зоні катання',
  Beginning : 'Початок',
  Block: 'Заблокувати',
  Unblock: 'Розблокувати',
  'Block device': 'Забл. пристрій',
  'Block engine': 'Забл. двигун',
  Blocked: 'Заблокований',
  Unlocked: 'Розблоковано',
  'Blocked-statistic': 'Заблоковані',
  'Blocked since': 'Дата блокування',
  'Bookd.': 'Броня',
  'Booking timeout': 'Таймаут бронювання',
  'Booking timed out': 'Час броні минув',
  Booking: 'Бронювання',
  Boundary: 'Кордони',
  Bonuses: 'Бонуси',
  Brief: 'Коротко',
  'Browser window is inactive': 'Вікно браузера неактивне',
  'Cancel transaction': 'Скасувати транзакцію',
  'Cancellation date': 'Дата скасування',
  'Can create price plans': 'Може створювати тарифні плани',
  Call: 'Зателефонувати',
  Canceled: 'Скасований',
  'canceled-status': 'Скасовано',
  Canceled_: 'Скасована',
  Cancelled: 'Скасований',
  'Cancelled orders': 'Скасовані замовлення',
  'Cannot change status because unit\'s owner is blocked': 'Неможливо змінити статус оскільки власник об\'єкта заблокований',
  Car: 'Автомобіль',
  Cars: 'Автомобілі',
  'Calculation method': 'Метод розрахунку',
  'Categories of transport licenses:': 'Категорії прав для транспорту:',
  Bikes: 'Велосипеди',
  Bike: 'Велосипед',
  Velomobiles: 'Веломобілі',
  'Velomobile price': 'Ціна веломобіля',
  voltage_abbreviation: 'В',
  Apartments: 'Квартири',
  Charge: 'Заряд',
  Couriers: 'Кур\'єри',
  Courier: 'Кур\'єр',
  'charge-level-low': 'Низький (приховано в додатку)',
  'charge-level-medium': 'Середній',
  'charge-level-high': 'Високий',
  'Charge/fuel level': 'Рівень заряду/палива',
  'Charge at finish': 'Заряд на фініші',
  'Charge at start': 'Заряд при старті',
  'Charge when plugged in': 'Заряд при підключенні',
  'Charge not found': 'Заряд не знайдено',
  'Charging stations': 'Зарядні станції',
  Boats: 'Човни',
  Boat: 'Човен',
  kWh: 'кВт⋅год',
  Partners: 'Партнери',
  'Port 1': 'Порт 1',
  'Port 2': 'Порт 2',
  'Port 3': 'Порт 3',
  'Port 4': 'Порт 4',
  'Port 1 connector type': 'Порт 1, тип конектора',
  'Port 2 connector type': 'Порт 2, тип конектора',
  'Port 3 connector type': 'Порт 3, тип конектора',
  'Port 4 connector type': 'Порт 4, тип конектора',
  Polygon: 'Полігон',
  Cashback: 'Кешбек',
  'Checkout bonus': 'Бонус при оформленні замовлення',
  'Charge before replacement': 'Заряд до заміни',
  'Charge after replacement': 'Заряд після заміни',
  'Choose a day of the week': 'Виберіть день тижня',
  'Choose a status': 'Виберіть статус',
  'Choose a color': 'Виберіть колір',
  'Choose a sign': 'Виберіть знак',
  'Choose status': 'Виберіть статус',
  'Choose the language for the rate information provided.': 'Вкажіть мову, якою надається інформація про тариф.',
  'Choose an integrator': 'Виберіть інтегратора',
  'Choose the regions': 'Виберіть регіони',
  'Choose access rights': 'Виберіть права доступу',
  'Choose the acquiring': 'Виберіть еквайринг',
  'Choose the payment service': 'Виберіть сервіси',
  'Choose a removable battery': 'Виберіть знімну АКБ',
  'Choose at least one language': 'Виберіть мінімум одну мову',
  'Choose file': 'Виберіть файл',
  'Choose from the list': 'Вибрати зі списку',
  'Choose a business model': 'Виберіть бізнес-модель',
  'Choose group of price plans': 'Виберіть групу тарифів',
  City: 'Місто',
  Circle: 'Окружність',
  Clear: 'Очистити',
  Client: 'Клієнт',
  'Number of selected clients': 'Кількість вибраних клієнтів',
  'Client authentication': 'Аутентифікація клієнта',
  'Number of clients selected': 'Обрано клієнтів',
  'Client awaiting confirmation': 'Клієнт очікує підтвердження',
  'Client blocked': 'Клієнт заблокований',
  'Client coord': 'Координати клієнта',
  'Client not confirmed': 'Клієнт не підтверджений',
  'Client photo': 'Фотографія клієнта',
  'Client price plans': 'Тарифи',
  'Client statistics': 'Клієнти',
  'Client selection': 'Вибір клієнтів',
  'Client assignment method': 'Метод призначення клієнтів',
  Clients: 'Клієнти',
  'Group of clients': 'Група клієнтів',
  'Client groups': 'Групи клієнтів',
  'Unit groups': 'Групи об\'єктів',
  'Client notification log': 'Журнал з клієнтів',
  'Clients who can pre-test the route': 'Клієнти, яким доступне попереднє тестування маршруту',
  'Client notification settings': 'Налаштування повідомлень щодо клієнтів',
  'Client notifications triggers log': 'Журнал повідомлень щодо клієнтів',
  'Client registration type': 'Тип реєстрації клієнта',
  'Client rating': 'Оцінка клієнта',
  'Client review': 'Відгук клієнта',
  'Client rating and review': 'Оцінка та відгук клієнта',
  'Log of notifications by clients': 'Журнал повідомлень за клієнтами',
  'Click here and then select position on map': 'Натисніть тут і виберіть місце на карті',
  'Close alarm with description': 'Закрити тривогу, вказавши опис',
  'Close alarm': 'Закрити тривогу',
  'Close door': 'Закрити двері',
  'Close window': 'Закрити вікно',
  'Close a branch': 'Закрити філію',
  'Closed by': 'Закрито користувачем',
  'Closed requests': 'Закриті',
  'Closed services': 'Закриті заявки',
  Closed: 'Закритий',
  'Closing date': 'Дата закриття',
  'Coin value': 'Вартість коіна',
  'Collapse menu': 'Згорнути меню',
  Color: 'Колір',
  Coordinates: 'Координати',
  'coordinates-ok': 'Є координати',
  'coordinates-invalid': 'Невалідні',
  'Color name': 'Назва кольору',
  'Color setting': 'Налаштування кольору',
  'Command descriptions': 'Описи команд',
  'Command name': 'Ім\'я команди',
  'Command text': 'Текст команди',
  'Command to disable speed limit' : 'Команда відключення обмеження швидкості',
  Commands: 'Команди',
  Command: 'Команда',
  'Command batch': 'Розсилання команд',
  'Command text can only contain latin letters, numbers, punctuation signs':
    'Текст команди може включати лише цифри, латинські літери, розділові знаки',
  'Commands were put to queue for sending': 'Команди були поставлені в чергу на відправлення',
  'Command was put to queue for sending': 'Команда була поставлена в чергу на відправлення',
  'Comment will be used for administrative purposes only and will not be available to the client.':
    'Коментар використовується тільки з адміністративною метою і не буде доступним клієнту.',
  Comments: 'Коментарі',
  Commentator: 'Коментатор',
  'Confirm booking': 'Підтвердити бронювання',
  'Confirm Email': 'Підтвердити Email',
  'connection-status-offline': 'Не на зв\'язку',
  'connection-status-online': 'На зв\'язку',
  'Connection status': 'Статус підключення',
  Connecting: 'Підключення',
  'Coordinated were copied to clipboard': 'Координати скопійовані в буфер обміну',
  'Geofence limit reached. Increase map zoom to show all geofences.':
    'Перевищено ліміт числа геозон на карті. Збільште масштаб, щоб бачити всі геозони',
  'Geopoint limit reached. Increase map zoom to show all geopoints.':
    'Перевищено ліміт числа геоточек на карті. Збільште масштаб, щоб бачити всі геоточки',
  'Unit limit reached. Increase map zoom to show all units.':
    'Перевищено ліміт кількості об\'єктів на карті. Збільште масштаб, щоб побачити всі об\'єкти',
  'Click on map to freeze coordinates': 'Клік по карті - фіксація координат',
  'Copy notification': 'Копіювати повідомлення',
  Count: 'К-ть',
  'Count-statistic': 'Кількість',
  Cost: 'Вартість',
  'Net cost': 'Собівартість',
  'Net cost information': 'Інформація щодо собівартості',
  'Count of selected units': 'Об\'єктів обрано',
  'Count of selected clients': 'Клієнтів обрано',
  'Cost of orders': 'Вартість замовлень',
  'Deal type': 'Тип угоди',
  Documents: 'Документи',
  'Document type': 'Тип документу',
  'Document type not selected': 'Тип документа не обраний',
  'Document format': 'Формат документа',
  'Document text (HTML)': 'Текст документа (HTML)',
  'Document addition method': 'Метод додавання документа',
  'Type not selected': 'Тип не вибраний',
  'Does not work': 'Не працює',
  Works: 'Працює',
  'Duration not selected': 'Тривалість не обрано',
  Send: 'Відправити',
  Settings: 'Налштування ',
  'Other settings': 'Інші налаштування',
  'Last command': 'Остання команда',
  'Sending time': 'Час відправлення',
  Compact: 'Компактний',
  Completed: 'Завершені',
  Components: 'Комплектуючі',
  'Components without s/n': 'Комплектуючі без с/н',
  'Comparison type': 'Тип порівняння',
  'Component models': 'Моделі комплектуючих',
  'Component types': 'Типи комплектуючих',
  Company: 'Компанія',
  Condition: 'Умова',
  Confirmed: 'Підтверджений',
  'Confirmed Client': 'Підтверджений Клієнт',
  'Confirmed documents': 'Підтверджені документи',
  Connection: 'З\'єднання',
  'Connection method': 'Метод підключення',
  'Connected by user': 'Підключена користувачем',
  'Connect tracker': 'Під’єднати трекер',
  'Connect battery': 'Під’єднати батарею',
  'Connected to an object': 'Під’єднаний до об\'єкта',
  'Connected to battery': 'Під’єднаний до батареї',
  'Copy of': 'Копія',
  Countries: 'Країни',
  Country: 'Країна',
  'Country Code': 'Код Країни',
  'Country of registration': 'Країна реєстрації',
  Create: 'Створити',
  Creation: 'Створення',
  'Create new SMS Gateway': 'Створити СМС-шлюз',
  'Create new acquirer': 'Створити еквайєр',
  'Create new balance package': 'Створити бонусний пакет',
  'Create new subscription': 'Створити абонемент',
  'Create new command description': 'Створити опис команди',
  'Create new end-user-price-plan': 'Створити клієнтський тарифний план',
  'Create new model group': 'Створити групу моделей',
  'Create new plan': 'Створити тарифний план для інтегратора',
  'Create new project': 'Створити проект',
  'Create new region': 'Створити регіон',
  'Create new insurance': 'Створити страхування',
  'Create new route': 'Створити маршрут',
  'Create new unit': 'Створити об\'єкт',
  'Create new unit model': 'Створити модель об\'єкта',
  'Create new unit-command-text': 'Створити команду для об\'єкта',
  'Create new unit-hw-model': 'Створити модель девайсу',
  'Create new user': 'Створити користувача',
  'Create a field': 'Створити поле',
  'Create unit group': 'Створити групу об\'єкта',
  'Creating a client group': 'Створення групи клієнтів',
  'Creating a group': 'Створення групи',
  'Creating a scooter': 'Створення самокату',
  'Creating a car': 'Створення автомобіля',
  'Creating a bicycle': 'Створення велосипеда',
  'Creating an electric bicycle': 'Створення електровелосипеда',
  'Creating a bicycle car': 'Створення веломобіля',
  'Creating a tricycle': 'Створення трициклу',
  'Creating a tracker': 'Створення трекера',
  'Creating a baby carriage': 'Створення візка',
  'Creating a trailer': 'Створення причепу',
  'Creating an electric quad bike': 'Створення електроквадроциклу',
  'Creating a charging station': 'Створення зарядної станції',
  'Creating business model': 'Створення бізнес-моделі',
  'Creation date': 'Дата відкриття',
  'Credit amount': 'Сума зарахування',
  Creator: 'Автор',
  Currency: 'Валюта',
  Changelog: 'Журнал змін',
  'Criteria for achieving the level': 'Критерії досягнення рівня',
  'Evaluation criterion': 'Критерій оцінки',
  Dashboard: 'Дашборд',
  'Data will not be updated': 'Дані не оновлюватимуться',
  'Data type': 'Тип даних',
  'Select data type': 'Виберіть тип даних',
  'Date of completion': 'Дата завершення',
  'Date of registration': 'Дата оформлення',
  'Date of creation': 'Дата створення',
  'Date of registration confirmation': 'Дата підтвердження реєстрації',
  'Date of issue of the document': 'Дата оформлення документа',
  'Date modified': 'Дата зміни',
  'Display order': 'Порядок відображення',
  'Select display order': 'Виберіть порядок відображення',
  Day: 'День',
  'Day of week': 'День тижня',
  Days: 'Днів',
  'Days before blocking': 'Кількість днів в мінус',
  'Default (cheapest)': 'За замовчуванням (найдешевший)',
  'Default language': 'Мова за замовчуванням',
  'Default timezone': 'Часовий пояс за замовчуванням',
  'Default country': 'За замовчуванням',
  'Default business model': 'Бізнес-модель за замовчуванням',
  Delete: 'Видалити',
  'Delete geofence?': 'Видалити геозону',
  'Delete price plan': 'Видалити тариф',
  'Delete language': 'Видалити мову',
  'Delete point': 'Видалити точку',
  'Delete route': 'Видалити маршрут',
  'Delete image': 'Видалити фото',
  'Delete video': 'Видалити відео',
  'Demand coefficient': 'Коефіцієнт попиту',
  'Demand assessment areas': 'Області оцінки попиту',
  'Demand area': 'Область оцінки попиту',
  Description: 'Опис',
  Destination: 'Призначення',
  'Destination type': 'Тип призначення',
  'Designated region': 'Регіон призначення',
  'Destination ID': 'ID Призначення',
  'Description title 1': 'Заголовок опису 1',
  'Description title 2': 'Заголовок опису 2',
  'Description title 3': 'Заголовок опису 3',
  'Description title 4': 'Заголовок опису 4',
  'Description value 1': 'Опис 1',
  'Description value 2': 'Опис 2',
  'Description value 3': 'Опис 3',
  'Description value 4': 'Опис 4',
  'Description speed mode': 'Опис, швидкісний режим',
  'Description price plan cost': 'Опис, вартість тарифу',
  Insurance: 'Страхування',
  'Insurance detail': 'Опис стрвхування',
  'Insurance link': 'Посилання на опис страхування',
  Insurers: 'Страховики',
  'Insurance price for admin': 'Вартість страхування для адміна',
  'Insurance price for integrator': 'Вартість страхування для інтегратора',
  'Insurance canceled': 'Страхування анульовано',
  'is awaiting for confirmation': 'Очікує підтвердження',
  Import: 'Імпорт',
  Repeater: 'Ретранслятор',
  'Unit list edit mode': 'Метод редагування списку об\'єктів',
  'Data content type': 'Зміст даних для імпорту',
  'Data for import': 'Дані для імпорту',
  'Import mode': 'Режим імпорту',
  'Unit assignment type': 'Тип призначення об\'єктів',
  Comment: 'Коментар',
  Detailed: 'Детально',
  'Detailed description': 'Детальний опис',
  'Device vendor': 'Виробник',
  'Device model': 'Модель',
  'Device info': 'Дані пристрою',
  Dispatcher: 'Диспетчер',
  Diagnostics: 'Діагностика',
  'Distance, m': 'Відстань, м',
  'Distance, km': 'Відстань, км',
  'Duration, days (0 - infinite)': 'Тривалість, дні (0 - без обмежень)',
  'Duration, hour': 'Тривалість, години',
  'Do you wish to change status and send command': 'Дійсно змінити статус та надіслати команду',
  'Do you wish to send command': 'Дійсно відправити команду',
  Document: 'Документ',
  'Document photo': 'Фотографія документа',
  'Document name (link to the document)': 'Назва документа (посилання на документ)',
  Documentation: 'Документація',
  'Document type not set': 'Тип документа не встановлено',
  'Document consent required': 'Потрібна згода з документом',
  'Document expiration date': 'Дата закінчення дії документа',
  'Document expiration date (Date of issue + 3 days)': 'Дата закінчення дії документа (Дата оформлення + 3 дні)',
  'draw polygon, please': 'Намалюйте полігон, будь ласка',
  'Documents with the "Country" assignment type are used to display to the client during registration and in the "Legal Documents" section. If you operate with multiple business models, you should add legal documents for each business model. If you need to add a document template populated with client and/or unit data, select the "Unit Type" assignment type.': 'Документи з типом призначення «Країна» використовуються для відображення клієнту під час реєстрації, а також у розділі «Правові документи». Якщо ви працюєте в різних бізнес-моделях, необхідно додати правові документи для кожної бізнес-моделі. Якщо вам потрібно додати шаблон документа, який заповнюється даними клієнта та/або об’єкта, виберіть тип призначення «Тип об’єкта».',
  'Document template can be provided in two formats: Text and HTML. When you add a document in text format, it will be displayed as is, without formatting. Adding a document in HTML format allows you to display the document exactly as you want.': 'Шаблон документа можна надати у двох форматах: Текст і HTML. Під час додавання документа в текстовому форматі він відображатиметься «як є», без урахування форматування. Додавання документа у форматі HTML дає змогу відобразити документ саме так, як ви цього бажаєте.',
  Driver: 'Водій',
  'Drivers license photo (Back side)': 'Водійські права фото (задня сторона)',
  'Drivers license photo (Front side)': 'Водійські права фото (передня сторона)',
  Edit: 'Редагувати',
  Editing: 'Редагування',
  'Edit Balance': 'Редагувати баланс',
  'Edit balance': 'Редагувати баланс',
  'Edit insurance': 'Редагувати страхування',
  'Edit subscription': 'Редагувати абонемент',
  'Edit fare': 'Редагувати тариф',
  'Edit balance package': 'Редагувати бонусний пакет',
  'Edit Client': 'Редагувати клієнта',
  'Edit command description': 'Редагувати опис команди',
  'Edit Geopoint': 'Редагувати геоточку',
  'Edit insurance balance': 'Редагувати баланс страхування',
  'Edit SMS Gateway': 'Редагувати СМС-шлюз',
  'Edit acquirer': 'Редагувати еквайра',
  'Edit end-user-price-plan': 'Редагувати тарифний план',
  'Edit model group': 'Редагувати групу моделей',
  'Edit price plan': 'Редагувати тарифний план',
  'Edit parts': 'Змінити частини',
  'Edit plan': 'Редагувати тарифний план для інтегратора',
  'Edit point': 'Редагувати точку',
  'Edit price plan structure': 'Редагувати структуру тарифного плану',
  'Edit project': 'Редагувати проект',
  'Edit promo code': 'Редагувати промокод',
  'Edit unit group': 'Редагувати групи об\'єктів',
  'Promo Codes': 'Промокоди',
  'Promo code activations log': 'Журнал активації промокодів',
  'Select a promocode project.': 'Виберіть проект, для якого створюється промокод.',
  'Select the project country in which the promo code will be applied.': 'Виберіть країну проекту, де буде застосовуватися промокод.',
  'Specify the owner of the promo code.': 'Вкажіть власника промокоду.',
  'Enter the promo code using numbers and capital letters without spaces or special characters.':
  'Введіть промокод, використовуючи цифри та великі літери без пробілів та спецсимволів.',
  'The description of the promo code is used for administrative purposes and is not available to clients.':
  'Опис промокоду використовується в адміністративних цілях і не є кінцевим клієнтам.',
  'If the promo code is intended for activation in all regions of the country, select type Country. If the promo code can be activated only in certain regions of the country, to be able to specify required regions, select type Regions.':
  'Якщо промокод призначений для активації в усіх регіонах країни, виберіть тип Країна. Якщо ви можете активувати промокод лише в окремих регіонах країни, виберіть тип Регіони, щоб вказати необхідні регіони.',

  'If the property doesn\'t have a cable lock, select "No Lock." When selecting a mechanical lock, the lock code will be displayed in the client\'s mobile app so the client can unlock it. The lock code is set in the settings for each unit. When selecting an electromechanical lock, the client\'s mobile app will allow the lock to be opened by sending a command for N seconds. Important: When the order completion screen is reached, the command to open the lock is sent automatically. This logic is not suitable for all types of electromechanical locks.': 'Якщо об’єкт не має тросового замка, виберіть тип «Без замка». При виборі механічного замка в мобільному застосунку клієнта відобразиться код замка, щоб клієнт міг його відстебнути. Код замка задається в налаштуваннях кожного об’єкта. При виборі електромеханічного замка в мобільному застосунку клієнта буде доступна функція відкриття замка шляхом надсилання команди на N секунд. Важливо: під час переходу на екран завершення замовлення команда на відкриття замка надсилається автоматично. Така логіка роботи підходить не для всіх типів електромеханічних замків.',

  'If the property has a removable battery, select the "Removable Battery" type. The battery compartment lock status will be displayed in the property card. If the unit doesn\'t have a removable battery, select "Non-removable Battery."': 'Якщо об’єкт оснащений знімним АКБ, вкажіть тип «Знімний АКБ». У картці об’єкта з’явиться відображення стану замка батарейного відсіку. Якщо об’єкт не оснащений знімним АКБ, вкажіть «Незнімний АКБ».',

  'If the hardware does not transmit the battery charge level, or the hardware transmits the value, but due to the specifics of its operation, the readings are incorrect, you can change the calculation method by specifying, for example, the voltage parameter and specifying the values of this parameter for a 0% charge level and a 100% charge level.': 'Якщо обладнання не передає рівень заряду АКБ або передає значення, але через специфіку роботи показники є некоректними, ви можете змінити метод обчислення заряду, вказавши, наприклад, параметр напруги та зазначивши значення цього параметра для рівня заряду 0% і 100%.',
  'Specify the regions in which clients can activate the promo code.': 'Вкажіть регіони, де клієнти зможуть активувати промокод.',
  'A client can activate a promo code once. Specify the maximum number of clients who can activate promo code.':
  'Клієнт може активувати промокод один раз. Вкажіть максимальну кількість клієнтів, які можуть активувати промокод.',
  'Enter the promo code amount in the country\'s currency. When promo code is activated, the specified amount will be credited to the client\'s balance.':
  'Введіть суму промокоду у валюті країни. При активації промокоду вказану суму буде зараховано на баланс клієнта.',
  'Enter a name for the geofence. We recommend using geofence type name and, for example, an address, so you can quickly find the geofence in the list if needed.': 'Вкажіть назву геозони. Рекомендуємо в назві використовувати тип геозони та, наприклад, адресу, щоб за потреби можна було швидко знайти геозону в списку.',
  'Specify the start date of the promo code. The promo code can\'t be activated before the start date.':
  'Вкажіть дату початку періоду дії промокоду. Активація промокоду недоступна до початку дії.',
  'Specify the expiration date of the promo code. Promo code activation is not available after expiration date. Leave the field blank if the promo code has no expiration date.':
  'Вкажіть дату закінчення періоду дії промокоду. Після закінчення періоду дії активація промокоду недоступна. Якщо період дії промокоду необмежений, залиште поле порожнім.',
  'Specify the icon owner. The icon owner, as well as their child users with editing permissions, will be able to edit and delete the icon.': 'Вкажіть власника іконки. Власник іконки, а також його дочірні користувачі з правами на редагування, зможуть редагувати та видаляти іконку.',
  'Specify the schedule owner. The schedule owner, as well as their child users with editing permissions, will be able to edit and delete the schedule.': 'Вкажіть власника розкладу. Власник розкладу, а також його дочірні користувачі з правами на редагування, зможуть редагувати та видаляти розклад.',
  'Enter the sum': 'Введіть суму',
  'Purchase Services': 'Сервіси покупки',
  'Purchase date': 'Дата купівлі',
  Purpose: 'Призначення',
  'Edit region': 'Редагувати регіон',
  'Edit route': 'Редагувати маршрут',
  'Edit service request': 'Редагувати заявку',
  'Edit unit': 'Редагувати об\'єкт',
  'Edit unit model': 'Редагувати модель',
  'Edit unit-command-text': 'Редагувати команду',
  'Edit unit-hw-model': 'Редагувати модель девайсу',
  'Edit user': 'Редагувати користувача',
  'Edit group': 'Редагувати групу',
  'Editing a group': 'Редагування групи',
  'Editing business model': 'Редагування бізнес-моделі',
  'Editable by integrator': 'Інтегратор може редагувати',
  'Editing a charging station': 'Редагування зарядної станції',
  'Editing a geofence': 'Редагування геозони',
  'Electric bike': 'Ел. велосипед',
  'Electric bike price': 'Ціна ел. велосипеда',
  Employment: 'Працевлаштування',
  'Full name of the courier': 'ПІБ кур\'єра',
  'Current employment': 'Поточне працевлаштування',
  Email: 'Email',
  'Employment type': 'Тип зайнятості',
  'Courier groups': 'Групи кур\'єрів',
  'Courier type': 'Тип кур\'єра',
  'The method of appointing couriers': 'Метод призначення кур\'єрів',
  'Employment history': 'Історія працевлаштування',
  'Email sender': 'Email відправника',
  'Enable authentication calls': 'Включити автентифікаційні дзвінки',
  'Enable password authentication for clients': 'Дозволити клієнтам аутентифікацію за паролем',
  'Enabled if unit status is': 'Увімкнено, якщо статус об\'єкта відповідний',
  'Enable OSM': 'Дозволити використання OSM',
  'Enable filtering of new coordinates': 'Увімкнути фільтрацію нових координат',
  'Enable immediately after saving': 'Увімкнути одразу після збереження',
  'Disable coordinate outlier filtering': 'Вимкнути фільтрацію викидів координат',
  Error: 'Помилка',
  'Error of transaction cancelling': 'Помилка скасування транзакції',
  'Error code': 'Код помилки',
  'Event: ': 'Подія: ',
  'Event log': 'Журнал подій',
  'Extended registration': 'Розширена реєстрація',
  Extended: 'Розширена',
  'Extended registration status': 'Статус проходження розширеної реєстрації',
  'Registration status': 'Статус реєстрації',
  'Registration forms': 'Форми реєстрації',
  'Extended registration type': 'Тип розширеної реєстрації',
  'Registration form': 'Форма реєстрації',
  'Expiry date': 'Дійсний до',
  'Expiration date': 'Термін придатності',
  'Ext. registration': 'Розш. реєстрація',
  'Failed transaction type': 'Тип невдалої транзакції',
  'Field must be a real number': 'Поле має бути числом',
  'Fields must match': 'Поля мають збігатися',
  'Field types': 'Типи полів',
  'Finish time': 'Час фінішу',
  'Finish-time': 'Час завершення',
  Finished: 'Завершено',
  finished: 'Завершений',
  'Finished orders': 'Завершені замовлення',
  'Financial operations': 'Фінансові операції',
  'Last financial operation': 'Остання фінансова операція',
  'Last operation': 'Остання операція',
  'Last modified': 'Остання зміна',
  'First 6': 'Перші 6',
  'Latest 4': 'Останні 4',
  'File not selected': 'Файл не вибран',
  'File types': 'Типи файлів',
  'Select file types': 'Виберіть типи файлів',
  'For balance in currency': 'Для балансу у валюті',
  'For subscriptions': 'Для абонементів',
  'Full description': 'Докладний опис',
  'Full screen mode': 'Повноекранний режим',
  'Full name of the Individual Entrepreneur': 'ПІБ Індивідуального підприємця',
  'statistics-finished': 'Завершені',
  'statistics-cancelled': 'Скасовані',
  'Active clients': 'Активні клієнти',
  'general-statistic-active': 'Активні',
  'Inactive clients': 'Неактивні клієнти',
  'Blocked clients': 'Заблоковані клієнти',
  'By default': 'За замовчуванням',
  'By default, linking a bank card to rent is required, regardless of the method of rent payment. If you want to provide services without the obligatory linking of a bank card, uncheck the box. Please note that disabling this setting may lead to the formation of debts and the inability to repay these debts.':
    ' За замовчуванням прив\'язка банківської картки для здійснення оренди обов\'язкова незалежно від способу оплати оренди. Якщо ви бажаєте надавати послуги без обов\'язкової прив\'язки банківської картки, приберіть прапорець. Звертаємо вашу увагу, що відключення цього налаштування може призвести до утворення заборгованостей та неможливістю погасити ці заборгованості.',
  '"By default" - holding is confirmed only in cases where the write-off amount is greater than or equal to the holding amount. "New customers" - holding is confirmed in the first order, regardless of the debit amount, the excess is credited to the client\'s balance. "All clients" - holding is always confirmed, the excess is credited to the client\'s balance.':
    '«За замовчуванням» – холдування підтверджується лише у випадках суми списання більшої або рівної сумі холдування. "Нові клієнти" - холдування підтверджується в першому замовленні незалежно від суми списання, надлишок зараховується на баланс клієнта. "Всі клієнти" - холдування підтверджується завжди, надлишок зараховується на баланс клієнта.',
  'Active users': 'Активні користувачі',
  'Inactive users': 'Неактивні користувачі',
  Filter: 'Фільтр',
  'Finish time of last order': 'Час завершення останнього замовлення',
  Firmware: 'Прошивка',
  'First name': 'Ім\'я',
  'First page passport photo': 'Перша сторінка паспорта з фотографією',
  'First rate selected by default': 'Вибір тарифу за замовчуванням',
  'Form validation error': 'Помилка перевірки форми',
  'Form type': 'Тип формы',
  'Fuel tank volume': 'Об\'єм паливного бака',
  'Fuel tank volume (L)': 'Об\'єм паливного бака (л)',
  'Fuel type': 'Тип палива',
  'GSM not found': 'GSM не знайдений',
  General: 'Загальна',
  'General statistics': 'Загальна статистика',
  'General information': 'Загальна інформація',
  'general-information': 'Загальні відомості',
  Geofences: 'Геозони',
  Geofence: 'Геозону',
  Geopoints: 'Геоточки',
  Geopoint: 'Геоточка',
  'Geopoint types': 'Типи геоточок',
  'geopoint-geometry-info-text': 'Вкажіть місцезнаходження геоточки в межах регіону. Геоточка має інформаційний характер. Після вказання місцезнаходження геоточки натисніть «Зберегти».',
  'Geo objects': 'Геооб\'єкти',
  'GPS status': 'Статус GPS',
  'GPS coordinates': 'Координати GPS',
  'gps-status-offline': 'GPS не на зв\'язку',
  'gps-status-online': 'GPS на зв\'язку',
  'Give the region a name': 'Задайте назву регіону',
  Groups: 'Групи',
  Group: 'Група',
  'HW model': 'Модель обладнання',
  'HW type': 'Тип обладнання',
  'Hair dryer': 'Фен',
  'Hardware ID': 'Ідентифікатор обладнання',
  'Hardware IMEI': 'IMEI обладнання',
  'Hardware models': 'Моделі обладнання',
  'Hardware id of new tracker': 'Ідентифікатор обладнання нового трекера',
  'Hardware model of new tracker': 'Модель обладнання нового трекера',
  'Hardware parameters': 'Параметри обладнання',
  'Hardware type': 'Тип обладнання',
  'Has attachment files': 'Є прикріплені файли',
  'Has bank cards': 'Є банківські картки',
  'Has transaction by bank cards': 'Є транзакція за банківськими картками',
  'Hasn\'t attachment files': 'Прикріплені файли відсутні',
  'Hasn\'t bank cards': 'Банківські картки відсутні',
  'Hasn\'t transaction by bank cards': 'Транзакції за банківськими картками відсутні',
  'Has serial numbers': 'Є серійні номери',
  Hidden: 'Прихований',
  'Hide unit in application': 'Приховати об\'єкт у програмі',
  'Hybrid vehicle': 'Гібридний',
  ID: 'ID',
  'Idle time more than (sec)': 'Тривалість простою більше (сек)',
  Idle: 'Простій',
  'If there is no rate translation into the language of the client\'s phone, client will be shown rate information in the default language. We recommend adding translation of the rate into the English and setting the default language of the rate to English.':
    'У разі відсутності перекладу тарифу на мову, що відповідає мові телефону клієнта, клієнту відображатиметься інформація про тариф мовою за замовчуванням. Рекомендуємо додати переклад тарифу на англійську мову та встановити англійську мову тарифу за замовчуванням',
  'Is published': 'Опублікований',
  'statistics-idle': 'Простоює',
  'general-statistics-idle': 'Простій',
  Image: 'Зображення',
  'Increase balance by amount': 'Збільшити баланс на суму',
  'Increase balance': 'Збільшити баланс',
  'Decrease balance': 'Зменшити баланс',
  'In rent': 'В оренді',
  'In service': 'В сервісі',
  'In order': 'В замовленні',
  'Hidden in the application': 'Прихований в додатку',
  'In service time': 'Час у сервісі',
  'In the test mode, the subscription is available only to the specified clients-testers. In combat mode, the subscription will be available to all customers in the region':
    'У тестовому режимі роботи абонемент доступний лише вказаним клієнтам-тестувальникам. В бойовому режимі абонемент буде доступний усім клієнтам у регіоні',
  'In the mobile application, the tariff in the list of tariffs will be displayed in the priority specified in this field.':
    'В мобільному додатку тариф у списку тарифів відображатиметься в пріоритеті, зазначеному у цьому полі.',
  Info: 'Інформація',
  'Information for clients': 'Інформація для клієнтів',
  'Information for the client': 'Інформація для клієнта',
  Integrator: 'Інтегратор',
  Interest: 'Значення',
  'Integrator price plans': 'Тарифні плани для інтегратора',
  Interface: 'Інтерфейс',
  'Interval (hh:mm - hh:mm)': 'Інтервал (чч:мм - чч:мм)',
  'Interval (hh:mm:ss - hh:mm:ss)': 'Інтервал (чч:мм:сс - чч:мм:сс)',
  'Interval start time must be less than end time': 'Час початку інтервалу має бути меншим ніж час закінчення',
  'Invalid e-mail address': 'Неправильна адреса електронної пошти',
  Journal: 'Журнал',
  Language: 'Мова',
  Languages: 'Мови',
  'Last Message Time': 'Час останнього повідомлення',
  'Last message': 'Останнє повідомлення',
  'Last name': 'Прізвище',
  'Last order time status': 'Час завершення останнього замовлення',
  'Last maintenance date': 'Дата останнього ТО',
  'Last comment': 'Останній коментар',
  'Last maintenance mileage': 'Кілометраж останнього ТО',
  'Lights off': 'Вимкнути світло',
  'Lights on': 'Включити світло',
  Loading: 'Завантаження',
  'Loading tracks': 'Завантаження треків',
  'Loading Units': 'Завантаження об\'єктів',
  'Loading Map': 'Завантаження карти',
  Location: 'Розташування',
  'location-status-parking-forbidden': 'Паркування заборонено',
  'location-status-parking-allowed': 'Паркування дозволено',
  'location-status-riding-forbidden': 'Їздити заборонено',
  'location-status-riding-allowed': 'Їздити дозволено',
  'Location status, riding': 'Статус розташування в зоні катання',
  Locator: 'Локатор',
  'Create locator': 'Створити локатор',
  '1 hour': '1 година',
  '2 hours': '2 години',
  '3 hours': '3 години',
  '4 hours': '4 години',
  '6 hours': '6 годин',
  '12 hours': '12 годин',
  '1 day': '1 день',
  '2 days': '2 дні',
  'Link expire time': 'Строк дії посилання',
  'Locator link copied to clipboard': 'Посилання на локатор скопійовано в буфер обміну',
  'Locator link': 'Посилання на локатор',
  'Lock type': 'Тип замку',
  'Lock price': 'Ціна замку',
  Login: 'Логін',
  'Login as': 'Увійти як',
  'Login history': 'Історія Увійти як',
  Logout: 'Вихід',
  'Log out': 'Вийти',
  Logo: 'Логотип',
  'Lower bound of the interval': 'Нижня межа інтервалу',
  'Main filter': 'Головний фільтр',
  'Maximum icon width': 'Максимальна ширина іконки 64px',
  'Maximum icon height': 'Максимальна висота іконки 64px',
  'Maintenance log': 'Журнал ТО',
  'Manual top-up': 'Ручне поповнення',
  'Manual assignment of clients to a group': 'Ручне призначення клієнтів на групу',
  'Create maintenance entry': 'Створити запис у журналі',
  Guests: 'Гостей',
  'Guest account type': 'Тип облікового запису гостя',
  'Edit maintenance entry': 'Редагувати запис в журналі',
  'Maintenance Interval Mileage, km': 'Інтервал ТО, км',
  'maintenance-expired': 'Закінчилось',
  'Map image': 'Зображення карти',
  'Map services': 'Картографічні сервіси',
  Map: 'Карта',
  'Maximum available number of uses': 'Максимальна кількість використань',
  'Mechanical lock code': 'Код механічного замку',
  'Merchant Id': 'ID Продавця',
  'Message Sender': 'Відправник Повідомлення',
  'Messages were sent': 'Повідомлення надіслані',
  'The message sending task has been sent for processing': 'Завдання на відправку повідомлень відправлено в обробку',
  'Message sent': 'Повідомлення надіслано',
  'Messages from trackers': 'Повідомлення від трекерів',
  'Method of conducting': 'Спосіб проведення',
  'Middle name': 'По-батькові',
  Mileage: 'Пробіг',
  'Minutes ago': 'Хвилин тому',
  'Mobile device': 'Моб. пристрій',
  Model: 'Модель',
  Moderator: 'Модератор',
  'Access to document moderation': 'Доступ до перевірки документів',
  'Model of new tracker': 'Модель нового трекера',
  'Model group': 'Група моделей',
  'Model groups': 'Групи моделей',
  'Model popularity': 'Популярність моделей',
  'Model ratio': 'Співвідношення моделей',
  Models: 'Моделі',
  Month: 'Місяць',
  Year: 'Рік',
  Multicasting: 'Розсилка',
  Name: 'Назва',
  'Name of new tracker': 'Ім\'я нового трекера',
  'Name of the level': 'Назва рівня',
  'Name and Surname': 'Ім\'я та прізвище',
  'Navigation button': 'Кнопка переходу',
  New: 'Новий',
  new: 'нове',
  new_ones: 'Нові',
  'New alarms': 'Нові тривоги',
  'New Balance': 'Новий баланс',
  'New Client': 'Новий клієнт',
  'New clients': 'Нові клієнти',
  'New requests': 'Нові',
  'New icon': 'Нова іконка',
  'New - the partner has not yet started working due to the various circumstances, so the payment according to the specified payment terms is not carried out. Upon the fact of readiness for work, the status of the partner changes to the Active status, according to which the calculation is carried out on the basis of the specified payment terms. Blocked - the user has no access to the system due to manual blocking of the account by the parent. Parent Blocked - The user is blocked due to the blocking of the parent account.':
    'Новий - партнер ще не приступив до роботи у зв\'язку з проведенням налаштувань, тому розрахунок за заданими умовами оплати не здійснюється. За фактом готовності до роботи статус партнера перетворюється на статус Активний, яким здійснюється розрахунок виходячи з зазначених умов оплати. Заблокований – користувач не має доступу до системи у зв\'язку з ручним блокуванням одного з керівників облікового запису. Заблокований керівник – користувач заблокований через блокування керівного облікового запису.',
  'Next maintenance': 'Наступне ТО',
  No: 'Ні',
  Yes: 'Так',
  'has-item-yes': 'є',
  'has-item-no': 'немає',
  'Not assigned': 'Не призначені',
  'Not operational': 'Несправний',
  'notification-enabled': 'Увімкнено',
  'Notification-enabled': 'Увімкнено',
  'Notification events': 'Спрацювання повідомлень',
  'Notification will be sent when the client\'s activity level increases to the current level.':
    'Повідомлення буде надіслано за умови підвищення рівня активності клієнта до поточного рівня.',
  'Notification will be sent when the client\'s activity level decreases to the current level.':
    'Повідомлення буде надіслано при зниженні рівня активності клієнта до поточного рівня.',
  'require_end_user_bank_card-enabled': 'Включена',
  'require_end_user_bank_card-off': 'Виключена',
  'Not selected': 'Не обраний',
  Source: 'Джерело',
  'One-time password source': 'Джерело одноразового пароля',
  'Source type': 'Тип джерела',
  'Source name': 'Джерело',
  'Skip areas where the object is stationary': 'Пропускати ділянки де об\'єкт нерухомий',
  'No alarms': 'Немає тривог',
  'No signal': 'Немає сигналу',
  'No information': 'Немає інформації',
  'No order finish photo': 'Немає фото завершення замовлення',
  'No client profile photo': 'Немає фото клієнта',
  'No photo of the courier': 'Немає фото кур\'єра',
  'No executor photo': 'Немає фото виконавця',
  'No unit model picture': 'Немає зображення моделі об\'єкта',
  'No new notifications': 'Немає нових повідомлень',
  'No cards available': 'Немає доступних карт',
  Now: 'Зараз',
  'Number of free cancellations': 'Кількість безкоштовних відмін бронювання',
  'Number of luggage spaces': 'Місць для багажу',
  'Number of seats': 'Посадкових місць',
  'Number of clients': 'Кількість клієнтів',
  'Number of couriers': 'Кількість кур\'єрів',
  'n/a': 'н/п',
  'n/i': 'н/и',
  Offline: 'Не на зв\'язку',
  Off: 'Вимк.',
  'geofence-disabled': 'Вимкнено',
  'geofence-active': 'Включено',
  'geofence-boundaries-info-text': 'Скористайтеся інструментами карти, щоб відобразити межі геозони. Після з’єднання точок натисніть “Зберегти”',
  'geofence-boundaries-tech-type-info-text': 'Скористайтеся інструментами карти, щоб відобразити межі території техніка. Після з’єднання точок натисніть «Зберегти»',
  'geofence-boundaries-demand-type-info-text': 'Скористайтеся інструментами карти, щоб відобразити межі області оцінки попиту. Після з’єднання точок натисніть «Зберегти»',
  'Switched off': 'Вимкнено',
  On: 'Увімк.',
  'Switched on': 'Включений',
  'Online available': 'Доступний',
  'Online in rent': 'Заброньований',
  'only with orders': 'Із замовленнями',
  'only without orders': 'Без замовлень',
  'Open door': 'Відкрити двері',
  'Open a branch': 'Відкрити філію',
  Operational: 'Справний',
  'Or command text': 'Або текст команди',
  Order: 'Замовлення',
  Task: 'Завдання',
  System: 'Система',
  'Balance before operation': 'Баланс до операції',
  'Balance after operation': 'Баланс после операції',
  'Order events': 'Події замовлення',
  'Order count': 'Кількість замовлень',
  'Order duration': 'Тривалість замовлень',
  Duration: 'Тривалість',
  'Order log': 'Журнал замовлення',
  'Order status': 'Стан замовлення',
  'Order completion photo': 'Фото завершення замовлення',
  'Reason for termination': 'Причина завершення',
  'Remaining minutes': 'Залишок хвилин',
  'Remaining trips': 'Залишок поїздок',
  Remaining: 'Залишок',
  'Remove from access': 'Зняти з доступу',
  'Removable battery': 'Знімна АКБ',
  Reading: 'Читання',
  'order-status-active': 'Катаються',
  'order-status-booked': 'Заброньовані',
  'order-status-available': 'Доступний',
  'order-status-not_available': 'Знятий з доступу',
  'order-status-on_charge': 'На зарядці',
  'order-status-at_warehouse': 'На складі',
  'order-status-service_mode': 'В сервісі',
  'order-status-under_repair': 'В ремонті',
  'order-status-donor': 'Донор',
  'order-status-stolen': 'Вкрадений',
  'order-status-free': 'Вільні',
  'order-status-hidden-in-application': 'Приховані у додатку',
  'order-status-paused': 'На паузі',
  'Ordinal number': 'Порядковий номер',
  Orders: 'Замовлення',
  'Orders count': 'Кількість замовлень',
  'OS type': 'Тип ОС',
  OS: 'ОС',
  'OS version': 'Версія ОС',
  'Out of rent': 'Поза орендою',
  Overview: 'Огляд',
  Owner: 'Власник',
  Points: 'Точки',
  Radius: 'Радіус',
  Notification: 'Повідомлення',
  Notifications: 'Повідомлення',
  'Create new notification': 'Створити нове повідомлення',
  'Edit notification': 'Редагувати повідомлення',
  'All units in these projects': 'Всі об\'єкти в проектах',
  'All units of these models': 'Всі об\'єкти моделей',
  'All units owned by these users': 'Об\'єкти, що належать користувачам',
  'Units located in regions': 'Об\'єкти, що знаходяться в регіонах',
  'All units loaded': 'Всі об\'єкти завантажені',
  'All orders loaded': 'Всі замовлення завантажені',
  'All orders loaded from cache': 'Всі замовлення завантажені з кешу',
  'All clients': 'Усі клієнти',
  'Registered clients': 'Зареєстровані клієнти',
  Registered: 'Зареєстровані',
  'Anonymous clients': 'Анонімні клієнти',
  Anonymous: 'Анонімні',
  'All executors': 'Усі виконавці',
  'My employee': 'Мої співробітники',
  'Co-owners': 'Співвласники',
  'Select co-owners': 'Виберіть співвласників',
  Message: 'Повідомлення',
  'Minimum charge': 'Мінімальний заряд ',
  'Maximum charge': 'Максимальний заряд',
  'Maximum speed': 'Максимальна швидкість',
  'Positioning loss more than (seconds)': 'Втрата позиціонування більш ніж (сек)',
  'position-job': 'Посада',
  'Postpone check': 'Відкласти перевірку',
  'Connection loss more than (seconds)': 'Втрата зв\'язку більш ніж (сек)',
  'Charge less than (percent)': 'Заряд менше ніж (%)',
  'Rent duration more than (seconds)': 'Тривалість оренди більше (сек)',
  'Rent duration': 'Тривалість оренди',
  'Registration type': 'Тип реєстрації',
  Registration: 'Реєстрація',
  'Movement shorter than (seconds)': 'Рух менше (сек)',
  'Movement longer than (seconds)': 'Рух більше (сек)',
  'Movement type': 'Тип руху',
  'Move to payment': 'Перейдіть до оплати',
  'Move up': 'Перемістити вгору',
  'Move down': 'Перемістити вниз',
  'Finish booking': 'Завершити бронювання',
  'Cancel booking': 'Відмінити бронювання',
  // "Canceled": "Скасовані",
  Finish: 'Завершити',
  'Find orders': 'Пошук замовлень',
  'Find by LBS': 'Знайти по LBS',
  'Fuel level %': 'Рівень палива %',
  'Cancel order': 'Скасувати замовлення',
  'Cancel subscription': 'Припинити передплату',
  'Order already closed': 'Замовлення вже закрите',
  'Are sure you want to finish this order': 'Дійсно завершити це замовлення',
  'Are sure you want to cancel this order': 'Дійсно скасувати це замовлення',
  'Are sure you want to cancel this transaction': 'Дійсно скасувати транзакцію',
  'Paid booking currency': 'Валюта платного бронювання',
  'Paid booking mode': 'Режим платного бронювання',
  'Paid booking price': 'Вартість платного бронювання',
  'Parameter name': 'Ім\'я параметра',
  'Passport photos': 'Фотографії паспорта',
  Password: 'Пароль',
  'Passwords do not match': 'Паролі не співпадають',
  'Password is required': 'Необхідно ввести пароль',
  'Payment method': 'Спосіб оплати',
  'Payment conditions': 'Умови оплати',
  'Payment procedure': 'Порядок оплати',
  'Payment currency': 'Валюта оплати',
  'Payment acceptance': 'Прийом платежів',
  'Payment services': 'Сервіси покупок',
  'Payment amount': 'Сума оплати',
  'Payment failed': 'Помилка проведення платежу',
  'Passport expiration date': 'Закінчення терміну дії паспорта',
  Citizenship: 'Громадянство',
  'Select citizenship': 'Вкажіть громадянство',
  Page: 'Сторінка',
  Period: 'Період',
  'Period of validity': 'Період дії',
  'Person type': 'Тип особи',
  'Personal data': 'Особисті дані',
  'Percentage of revenue': 'Відсоток від виторгу',
  'Percentage of order value': 'Відсоток від вартості замовлення',
  'Pending confirmation': 'Очікують підтвердження',
  Phone: 'Телефон',
  'Phone / SIM number': 'Телефон / Номер SIM',
  'Photo report': 'Фотозвіт',
  'Photo of Registration': 'Фото прописки / реєстрації',
  'Photo of Registration (New)': 'Фото прописки / реєстрації (Нове)',
  'Phone number': 'Номер телефону',
  'Phone manufacturer and model': 'Виробник і модель телефону',
  'Photo gallery': 'Фотогалерея',
  photo: 'фото',
  Photography: 'Фотографія',
  'Plate number': 'Держ. номер',
  'Planned payment terms': 'Заплановані умови оплати',
  'Place of Birth': 'Місце народження',
  'Place of registration': 'Місце реєстрації',
  'Place of residence': 'Місце проживання',
  'please, wait': 'будь ласка, зачекайте',
  Position: 'Місцезнаходження',
  Polyline: 'Полілінія',
  'please wait': 'будь ласка, зачекайте',
  'Please add maintenance record': 'Додайте записи про техобслуговування',
  'Please set up car mileage': 'Вкажіть поточний пробіг автомобіля',
  'Please set up maintenance interval': 'Вкажіть інтервал ТО',
  'Please provide a reason (Optional)': 'Вкажіть причину (Необов\'язково)',
  'Please enter your phone number in international format: start with "+" and include the country code.':
    'Введіть номер телефону в міжнародному форматі: почніть із «+» та вкажіть код країни.',
  'Please specify the name of the component type': 'Вкажіть назву типу комплектуючого',
  'Please specify the name of the component model': 'Вкажіть назву моделі комплектуючого',
  'Please provide a free-form description of the model, such as specifications. This field is optional. and is currently only visible for the component model.':
    'Вкажіть опис моделі у довільній формі, наприклад, характеристики. Поле не обов\'язкове для заповнення і зараз відображається тільки у моделі комплектуючого',

  'Please enter the maximum GPS speed value at which the coordinates will be considered valid. Filtering is only applied to online messages to prevent outliers and to pin the unit on the map using the latest valid coordinates. The actual coordinates sent by the equipment are saved in the message history.': 'Вкажіть максимальне значення швидкості за GPS, за якого координати вважатимуться валідними. Фільтрація застосовується лише до онлайн‑повідомлень, щоб запобігти викидам і фіксувати об’єкт на карті за останніми валідними координатами. В історії повідомлень зберігаються фактичні координати, надіслані обладнанням.',
  'Please note that this functionality is intended exclusively for courier-type business models. In case of leaving a speed limit geofence, a general speed limit command of the region will be sent to devices':
    'Звертаємо вашу увагу, що даний функціонал призначений виключно для бізнес‑моделі кур’єрського типу. Під час виїзду за межі геозони обмеження швидкості на пристрої буде надсилатися команда загального обмеження швидкості в регіоні',
  'Power reserve': 'Запас ходу',
  'Power reserve (km)': 'Запас ходу (км)',
  'Previously Balance': 'Попередній баланс',
  Price: 'Ціна',
  'Price 1': 'Ціна 1',
  'Price 2': 'Ціна 2',
  'Price 3': 'Ціна 3',
  'Price 4': 'Ціна 4',
  'Price in currency': 'Ціна у валюті',
  'Price per unit': 'Ціна за об\'єкт',
  'Price plan': 'Тариф',
  'Price plan creation': 'Створення тарифного плану',
  'Price plans': 'Тарифи',
  'Price plan count': 'Кількість тарифних планів',
  'Price plan type': 'Тип тарифу',
  'Price plan preview': 'Попередній тариф',
  'Price plan can be assigned either to all objects of a specific user, or to all objects of a certain model, or to specific objects. To display the selection field for the desired destination, you must select the type of destination.':
    'Тариф можна призначити або на всі об\'єкти конкретного користувача, або на всі об\'єкти визначеної моделі, або на конкретні об\'єкти. Для відображення поля вибору необхідного призначення необхідно вибрати тип призначення.',
  Priority: 'Пріоритет',
  Process: 'Процес',
  Profile: 'Профіль',
  Project: 'Проект',
  'Profile photo': 'Фотографія профілю',
  'Project Country': 'Країна',
  'Project Name': 'Проект',
  'Project countries': 'Країни',
  Projects: 'Проекти',
  'Promo code': 'Промокод',
  'Promo code copied to clipboard': 'Промокод скопійовано в буфер обміну',
  'promotions-and-news-publish-description':
  'Перед публікацією рекомендуємо перевірити всю інформацію.' +
      ' У разі редагування вже опублікованої новини публікацію буде знято автоматично' +
    ' та переведено у статус “Підготовлено” для повторної публікації.',
  'promotions-and-news-remove-from-publication-description':
    'Новина більше не буде доступна клієнтам, але збережеться у вашому списку новин.' +
    ' У разі необхідності повторної публікації необхідно відредагувати новину,' +
    ' після чого новину буде автоматично переведено у статус “Підготовлено” для повторної публікації.',
  'UID code copied to clipboard': 'UID скопійовано в буфер обміну',
  Prohibited: 'Заборонено',
  Published: 'Опубліковано',
  Publish: 'Опублікувати',
  'Push history': 'Історія push-повідомлень',
  'Push notifications': 'Push-сповіщення',
  'Push notification': 'Push-повідомлення',
  'Push broadcast': 'Розсилка push-повідомлень',
  'Push notification text for client': 'Текст push-повідомлення для клієнта',
  'Push notification text': 'Текст push-повідомлення',
  'Push notification to send when user has free cancellations left': 'Push-повідомлення про кількість безкоштовних скасувань, що залишилися',
  'Push notification to send when booking is paid': 'Push-сповіщення при платному бронюванні',
  'Push notification translations': 'Переклади push-сповіщення',
  Pinned: 'Закріплено',
  'Not pinned': 'Чи не закріплена',
  'Pin news': 'Закріпити новину',
  'Pinned post': 'Закріплений запис',
  'Rapid message delivery service': 'Сервіс оперативної доставки повідомлень',
  Rate: 'Тариф',
  'Rate of cancellation': 'Відсоток скасування',
  'Rates for subscriptions': 'Тарифи для абонементів',
  Rates: 'Тарифи',
  'Ready to order': 'Готово для замовлення',
  'Region Name': 'Назва регіону',
  Reason: 'Причина',
  Refresh: 'Оновити',
  Refunds: 'Повернення',
  Refund: 'Повернення',
  'Refunds(bank)': 'Повернення(банківські)',
  Region: 'Регіон',
  Regions: 'Регіони',
  'Registration date': 'Дата реєстрації',
  'Registration number': 'Реєстраційний номер',
  'Registration number\'s numeric part': 'Числова частина реєстраційного номера',
  'Enter registration number\'s numeric part': 'Введіть числову частину реєстраційного номера',
  'Registration status in the system': 'Статус реєстрації в системі',
  'Reg. number': 'Рег. номер',
  'Reg. number not specified': 'Рег. номер не заданий',
  Remove: 'Вилучити',
  'Remove translate': 'Вилучити переклад',
  Removed: 'Вилучено',
  'Remove document': 'Вилучити документ',
  'Remove from publication': 'Зняти з публікації',
  'Removed from publication': 'Знято з публікації',
  'Rent from integrator to integrator': 'Передано в оренду від інтегратора до інтегратора',
  'Rent to integrator': 'Передано в оренду інтегратору',
  'Repeat password': 'Повторіть пароль',
  'Repeat the previously entered password to confirm the match.': 'Повторіть раніше введений пароль для підтвердження відповідності.',
  Repeaters: 'Ретранслятор',
  Replenishment: 'Поповнення',
  'repeater-enabled': 'Включено',
  'region-boundaries-info-text': 'Скористайтеся інструментами карти, щоб намалювати межі регіону. Після з’єднання точок натисніть “Зберегти”',
  Protocol: 'Протокол',
  Port: 'Порт',
  'Enable repeater for all units matching filter': 'Включити ретрансляцію для всіх об\'єктів, що задовольняють фільтру',
  'Disable repeater for all units matching filter': 'Вимкнути ретрансляцію для всіх об\'єктів, які відповідають фільтру',
  'repeating-enabled': 'Вкл',
  'Repeater information': 'Відомості про ретранслятор',
  'For courier shifts': 'Для змін кур\'єрів',
  'For shifts': 'Для змін',
  'Select protocol': 'Виберіть протокол',
  'Select unit assignment type': 'Виберіть тип призначення об\'єктів',
  Reports: 'Звіти',
  Request: 'Запит',
  'Requests in progress': 'В роботі',
  'Required driver experience, years': 'Необхідний стаж водіння, років',
  'Required driver age': 'Необхідний вік водія',
  'Required field': 'Необхідно заповнити поле',
  'Required step': 'Обов\'язковий крок',
  'Required to fill out': 'Обов\'язково до заповнення',
  'Required question': 'Обов\'язкове питання',
  'Reservation info': 'Інформація про бронювання',
  Reset: 'Скидання',
  'Residence address': 'Адреса місця проживання',
  Response: 'Відповідь',
  'Restart SIM': 'Перезапуск SIM',
  'Restrict by unit types and models': 'Обмежити за типом та моделлю об\'єкта',
  Results: 'Результати',
  'Returning clients': 'Клієнти, які повернулись',
  Revenue: 'Виторг',
  Riding: 'Їде',
  Role: 'Роль',
  'Route points': 'Точки маршруту',
  'Routes purchases': 'Покупки маршрутів',
  Satellites: 'Супутники',
  'Satellites not found': 'Супутники не знайдені',
  Save: 'Зберегти',
  Saved: 'Збережено',
  Schedule: 'Розклад',
  'New schedule': 'Новий розклад',
  'Existing schedule': 'Існуючий розклад',
  'Name of new schedule': 'Назва нового розкладу',
  'Enter name of new schedule': 'Введіть назву нового розкладу',
  'Select schedule': 'Виберіть розклад',
  'Geofence schedule': 'Розклад геозон',
  'Price plan schedule': 'Розклад тарифів',
  'schedule-plan': 'Запланувати',
  'Schedule templates': 'Шаблони розкладу',
  'Schedule template': 'Шаблон розкладу',
  'Schedule is enabled': 'Розклад включено',
  'schedule changes in payment terms at the end of the current billing period':
    'запланувати зміни умов оплати після закінчення поточного розрахункового періоду',
  'Scope of assessment': 'Область оцінки',
  Scooter: 'Самокат',
  Scooters: 'Самокати',
  'Send a command': 'Надіслати команду',
  'Send command "Disable service mode"': 'Надіслати команду "Вимкнути сервісний режим"',
  'Send command "Enable service mode"': 'Надіслати команду "Увімкнути сервісний режим"',
  'Send command to unit': 'Надіслати команду',
  'Send push notification to client': 'Надіслати push-повідомлення клієнту',
  'Send push notification': 'Надіслати push-сповіщення',
  'Send push notification to client after registration': 'Надіслати push-повідомлення клієнту після реєстрації',
  'Send a notification to the client about the level change': 'Надсилати повідомлення клієнту про зміну рівня',
  'Use balance payment method only for orders': 'Оплата замовлень лише за балансом',
  'Automatic balance replenishment': 'Автопоповнення балансу',
  'Auto top-up disabled': 'Автопоповнення балансу вимкнено',
  'Auto top-up enabled': 'Автопоповнення балансу увімкнено',
  'Automatic data substitution templates:': 'Шаблони автопідстановки даних:',
  'Send to all clients': 'Надіслати всім клієнтам',
  'Sender name': 'Ім\'я відправника',
  'Serial number': 'Серійний номер',
  'Serial numbers': 'Серійні номери',
  'Serial / State number': 'Серійний / Держ. номер',
  'Server Error': 'Помилка Сервера',
  'Server error': 'Помилка сервера',
  'Service mode': 'Сервісний режим',
  SM: ' CP',
  'Service enabled': 'Сервіс увімкнено',
  'Service is online': 'Сервіс працює',
  'Service requests': 'Заявки',
  'Service request': 'Заявка',
  'Service prices': 'Ціни на послуги',
  Service: 'Послуга',
  Services: 'Послуги',
  'Service 1': 'Послуга 1',
  'Service 2': 'Послуга 2',
  'Service 3': 'Послуга 3',
  'Service 4': 'Послуга 4',
  'Services in progress': 'Заявки у роботі',
  'Setting up events': 'Налаштування подій',
  'Setting up the sender of email notifications': 'Налаштування відправника Email оповіщень',
  'Setting up Telegram Gateway': 'Налаштування Telegram Gateway',
  'Setting up Captcha': 'Налаштування Captcha',
  'Set the speed limit disable command': 'Встановити команду вимкнення обмеження швидкості',
  'Set a schedule': 'Встановити розклад',
  'Shopping service - for buying bonus packages, routes, season tickets, travel cards':
    'Сервіс покупок - для покупки бонусних пакетів, маршрутів, абонементів, проїздних',
  Show: 'Показати',
  'Short description': 'Короткий опис',
  'Show in mobile application': 'Показувати в мобільному додатку',
  'Show unit in application': 'Показати об\'єкт у мобільному додатку',
  'Show units in mobile application': 'Показувати об\'єкти в мобільному додатку',
  'show-in-application': 'Видно',
  'Show-in-application': 'Видно',
  'Show units only on visible map area': 'Показувати лише об\'єкти у видимій області',
  'Show geofences': 'Показати геозони',
  'Hide geofences': 'Сховати геозони',
  'Show region': 'Показати регіон',
  'Hide region': 'Сховати регіон',
  'Only on visible map area': 'Тільки у видимій області',
  'Signal off': 'Вимк. звук. сигнал',
  'Signal on': 'Увімк. звук. сигнал',
  'Siren on': 'Сирена увімкнена',
  'Siren off': 'Сирена вимкнена',
  'SIM Balance': 'Баланс SIM',
  'Simple registration': 'Проста реєстрація',
  'Signing text': 'Текст підписання',
  Simple: 'Проста',
  'SMS Gateway': 'SMS-шлюзи',
  'Sms template must include [[code]] placeholder': 'Шаблон SMS повинен містити текст [[code]]',
  'SMTP Mail Host': 'Поштовий хост SMTP',
  'SMTP server port': 'Порт SMTP-сервера',
  'Sorting priority': 'Пріоритет сортування',
  Sort: 'Сортування',
  'SIM number': 'Номер SIM',
  Spacious: 'Просторий',
  Speed: 'Швидкість',
  'Speed limit': 'Обмеження швидкості',
  'Speed limit command': 'Команда обмеження швидкості',
  'Speed limit geofences': 'Геозони обмеження швидкості',
  Start: 'Розпочати',
  'Start time': 'Час початку',
  'Start checking': 'Розпочати перевірку',
  'Start of the billing period': 'Початок розрахункового періоду',
  'Start of order': 'Початок замовлення',
  'Start shift': 'Почати зміну',
  State: 'Стан',
  Status: 'Статус',
  'Date of blocking': 'Дата блокування',
  'status-last-order-finish-time-perfect': 'менше 8 годин',
  'status-last-order-finish-time-ok': 'від 8 до 16 годин',
  'status-last-order-finish-time-warning': 'від 16 до 24 годин',
  'status-last-order-finish-time-alarm': 'більше 24 годин',
  Step: 'Крок',
  'Steps of registration': 'Етапи проходження реєстрації',
  Statistic: 'Статистика',
  'Subscription fee': 'Абонентська плата',
  Subscriptions: 'Абонементи',
  Subscription: 'Абонемент',
  'Subscription status': 'Стан абонементу',
  'Such value already exists in this project': 'Таке значення вже використовується у цьому проекті',
  'Sum of transactions': 'Сума за транзакціями',
  'Sum of geofences': 'Сума геозон',
  'Suspicious customer': 'Підозрілий клієнт',
  'Suspicious clients': 'Підозрілі клієнти',
  Summary: 'Разом',
  Supply: 'Попит',
  Support: 'Допомога',
  Superuser: 'Суперкористувач',
  'Support contacts': 'Контакти техпідтримки',
  'Successful transactions': 'Успішні транзакції',
  'Sum of all successful banking transactions for the selected period': 'Сума всіх успішних банківських транзакцій за обраний період',
  'Sum of all bonuses provided for the selected period': 'Сума всіх наданих бонусів за обраний період',
  'Sum of arrears on orders and fines for the selected period': 'Сума заборгованостей за замовленнями та штрафами за обраний період',
  'Sum of the value of orders for the selected period': 'Сума вартості замовлень за обраний період',
  Target: 'Ціль',
  'Target type': 'Тип цілі',
  'Tariff settings': 'Налаштування тарифів',
  Demand: 'Попит',
  'Use this tariff only at a certain level of demand': 'Використовувати тариф лише за певного рівня попиту',
  'Use Google Hybrid': 'Використовувати Google Hybrid',
  'Use GoMap.Az': 'Використовувати GoMap.Az',
  'Minimum demand, percent': 'Мінімальний попит, %',
  'Maximum demand, percent': 'Максимальний попит, %',
  'Minimum demand': 'Мінімальний попит',
  'Maximum demand': 'Максимальний попит',
  Tasks: 'Завдання',
  'Balance changing': 'Зміна балансу',
  'Activate to provide access to the functionality of manual changing the client\'s balance.':
    'Активуйте, щоб надати доступ до функціоналу ручної зміни балансу клієнта',
  'Promocode creating': 'Створення промокодів',
  'Activate to provide access to the functionality of creating promocodes.':
    'Активуйте, щоб надати доступ до функціоналу створення промокодів.',
  'Technical support': 'Технічна підтримка',
  'Text of push notification after registration': 'Текст пуш-повідомлення після реєстрації',
  'These condition types cannot be combined': 'Обрані типи умов в повідомленні не можна комбінувати',
  'The name of the subscription will be displayed in the mobile application. You can use emoji for emphasis':
    'Назва абонементу відображатиметься в мобільному додатку. Можна використати emoji для акцентування уваги',
  'The subscription will be available only to the specified testers.':
    'Абонемент буде доступний лише вказаним клієнтам-тестувальникам.',
  'The validity period of the subscription condition is specified in days. 1 day = 24 hours.':
    'Період дії умови абонементу вказується в днях. 1 день = 24 годинам.',
  'The condition with the minimum cost is marked to display the minimum cost of the subscription in the mobile application':
    'Зазначається умова з мінімальною вартістю для відображення мінімальної вартості абонементу в мобільному додатку',
  'The name of the tariff will be displayed in the mobile application both in the tariff preview of the tariff list and in the detailed tariff card.':
    'Назва тарифу відображатиметься у мобільному додатку як у прев\'ю тарифу списку тарифів, так і у докладній картці тарифу. ',
  'The country of the project in which the tariff will be presented is indicated':
    'Вказується країна проекту, в якій буде представлений тариф',
  'The regions in which the tariff will be presented are indicated':
    'Вказуються регіони, в яких буде представлено тариф ',
  'The currency in which the prices will be presented is indicated':
    'Вказується валюта, в якій будуть представлені ціни тарифу',
  'The owner of the tariff is indicated. The owner will be given the opportunity to manage the tariff':
    'Вказується власник тарифу. Власнику буде надано можливість управління тарифом',
  'The owner of the subscription is indicated. The owner will be given the opportunity to manage the subscription':
    'Вказується власник абонементу. Власнику буде надано можливість керувати абонементом',
  'The name of the charged service is indicated, for example, Trip start, Trip, Pause, etc. The name of the service is displayed in the fare card in the mobile application':
    'Вказується назва послуги, що тарифікується, наприклад, Старт поїздки, Поїздка, Пауза та ін. Назва послуги відображається в картці тарифу в мобільному додатку',
  'The price of service 1 is indicated, for example, 10 rubles, 5 rubles / min, 300 rubles / hour, etc.':
    'Вказується ціна послуги 1, наприклад, 10 руб., 5 руб/хв, 300 руб/год і т.д.',
  'The price of service 2 is indicated, for example, 10 rubles, 5 rubles / min, 300 rubles / hour, etc.':
    'Вказується ціна послуги 2, наприклад, 10 руб., 5 руб/хв, 300 руб/год і т.д.',
  'The price of service 3 is indicated, for example, 10 rubles, 5 rubles / min, 300 rubles / hour, etc.':
    'Вказується ціна послуги 3, наприклад, 10 руб., 5 руб/хв, 300 руб/год і т.д.',
  'The price of service 4 is indicated, for example, 10 rubles, 5 rubles / min, 300 rubles / hour, etc.':
    'Вказується ціна послуги 4, наприклад, 10 руб., 5 руб/хв, 300 руб/год і т.д.',
  'The cost of insurance is indicated in an arbitrary format, indicating the currency, for example, 35 rubles. In the specified form, the cost of insurance will be displayed in the mobile application.':
    'Вказується вартість страхування у довільному форматі із зазначенням валюти, наприклад, 35 руб. У зазначеному вигляді вартість страхування відображатиметься у мобільному додатку.',
  'The insurance description is displayed in the mobile application on a separate screen. Each paragraph is displayed with a bullet. The description must contain the sums insured':
    'Опис страхування відображається у мобільному додатку на окремому екрані. Кожен абзац відображається з маркером. В описі повинні бути суми страхування',
  'The internal name is displayed only in the admin panel and is not available to clients in the mobile app.': 'Внутрішня назва відображається лише в панелі адміністратора і недоступна клієнтам у мобільному застосунку',
  'The minimum battery charge of the object is specified, at which the tariff can be displayed in the mobile application for the object.':
    'Вказується мінімальний заряд АКБ об\'єкта, за яким можна відображати тариф у мобільному додатку для об\'єкта.',
  'The name of the object will be displayed in the client interface in the object card':
    'Назва об\'єкта відображатиметься в інтерфейсі клієнта у картці об\'єкта',
  'The serial number or the state number depending on the selected object type is indicated. This information is only displayed in the admin panel.':
    'Вказується серійний номер або державний номер, залежно від вибраного типу об\'єкта. Ця інформація відображається лише на панелі адміністратора.',
  'The object status depends on the availability of the object in the client application, the activity of the hardware service mode, etc. Please, pay attention that when the object is set to "Available" status, subscription fee for the object in the current month is activated. We recommend not to transfer object to the status "Accessible" before full adjustment and check of the equipment functioning!':
    'Від статусу об\'єкта залежить доступність об\'єкта клієнтського додатку, активність апаратного сервісного режиму та інших. Звертаємо вашу увагу на те, що при переведенні об\'єкта в статус «Доступний» активується абонентська плата за об\'єкт у поточному місяці. Рекомендуємо не переводити об\'єкт у статус «Доступний» до повного налаштування та перевірки функціонування обладнання!',
  'The integrator\'s client is considered to be the person who has placed the order for the integrator\'s unit. Client in a region is considered to be the person who has placed the order for the integrator\'s unit in a specific region.': 'Клієнт інтегратора визначається за наявністю замовлення об’єкта в інтегратора. Клієнт у регіоні визначається за наявністю замовлення об’єкта інтегратора в конкретному регіоні.',
  'The number must be greater than 0': 'Число має бути більше 0',
  'The number must not be less than 0': 'Число не має бути менше 0',
  'The number must not exceed the limit': 'Число не може перевищувати ліміт',
  'The number must not be more than': 'Число не має бути більше',
  'Field value must be non-negative number': 'Значення поля має бути невід\'ємним числом',
  'The number must be an integer': 'Число має бути цілим',
  'The name of the organization is used in acceptance certificates and other documents. Specify the name of the organization in the format LLC "Ivanov", SE Ivanov Ivan Ivanovich.':
    'Назва організації використовується в актах прийому-передачі та інших документах. Вкажіть назву організації у форматі ТОВ «Іванов», ПП Іванов Іван Іванович.',
  'Time interval is incorrect': 'Некоректний інтервал часу',
  'The first 6 digits of the card': 'Перші 6 цифр карти',
  'The last 4 digits of the card': 'Останні 4 цифри карти',
  'The subscription will be activated for the group\'s clients upon turning on the subscription by the user. Specify the expiration date of the subscription, upon which the subscription will be deactivated for group clients.':
    'Абонемент буде активовано клієнтам групи за фактом включення абонементу користувачем. Вкажіть дату закінчення терміну дії абонементу, при настанні якої абонемент буде деактивовано у клієнтів групи.',
  'The image must be in PNG or JPEG format. The aspect ratio must be 16:9 for correct display.':
    'Зображення має бути у форматі PNG або JPEG. Для коректного відображення співвідношення сторін має становити 16:9.',
  'The image must be in PNG or JPEG format. The aspect ratio must be 1:1 for correct display. Recommended resolution is 300px * 300px':
    'Зображення має бути у форматі PNG або JPEG. Для коректного відображення співвідношення сторін має становити 1:1. Рекомендована роздільна здатність 300px * 300px.',
  'This subscription can have only one condition': 'Даний абонемент може мати лише одну умову',

  'The hardware model name is unique within the system. Therefore, to avoid errors, it is recommended to add the project name or other unique identifying characteristics to the name. The name may only contain letters, numbers, hyphens, and underscores.': 'Назва моделі обладнання є унікальною в системі. Тому, щоб уникнути помилок, рекомендується додавати до назви назву проєкту або інші унікальні відмінні ознаки. Назва може містити лише літери, цифри, дефіси та підкреслення',
  'The client\'s activity level is assessed daily. The assessed activity period is the last 30 days. One of 2 criteria is used for assessment: order value or order duration. When selecting the assessment criterion by order value, the amount of paid orders in the country\'s currency required to achieve the level. This takes into account payments both by balance and by bank card. When selecting the assessment criterion by order duration, the total duration of all completed orders over the last 30 days required to achieve the level.':
    'Оцінка рівня активності клієнта здійснюється щоденно. Період, що оцінюється, охоплює останні 30 днів. Для оцінки використовується один із двох критеріїв: вартість замовлень або тривалість замовлень.\n' +
    'У разі вибору критерію за вартістю замовлень зазначається сума оплачених замовлень у валюті країни, необхідна для досягнення відповідного рівня. При цьому враховуються оплати як з балансу, так і з банківської картки.\n' +
    'У разі вибору критерію за тривалістю замовлень зазначається загальна тривалість усіх завершених замовлень за останні 30 днів, необхідна для досягнення рівня.',
  'The amount of paid orders in the country\'s currency required to achieve the level': 'Вказується необхідна для досягнення рівня сума оплачених замовлень у валюті країни',
  'The total duration of all completed orders over the last 30 days required to achieve the level.':
    'Вказується необхідна для досягнення рівня загальна тривалість усіх завершених замовлень за останні 30 днів.',
  'The opening of the office means that the office is ready to process requests for services provided and will be available in the mobile application for couriers.':
    'Відкриття офісу означає, що офіс готовий до обробки заявок на послуги і буде доступний в мобільному додатку для кур\'єрів.',
  'There are not enough funds on the balance of the personal account. The objects are hidden and are not available for rent to clients. In order to resume the service it is necessary to replenish the balance of the personal account.':
  'На балансі особового рахунку недостатньо грошових коштів. Об\'єкти приховані та недоступні для оренди клієнтам. Для відновлення обслуговування необхідно поповнити баланс особового рахунку.',
  'There is a debt on the balance of your personal account. To avoid blocking the account, you must pay the debt before the deadline.': 'На балансі особового рахунку утворилася заборгованість. Щоб уникнути блокування облікового запису необхідно погасити заборгованість до настання крайнього терміну.',
  'There are two subtypes available for the "Finish Allowed" geofence: Simple and Bonus. "Simple" geofences are used to specify the area where the order can be completed. "Bonus" geofences are used to automatically credit bonuses to the client\'s balance upon completion of the trip. Important: the bonus will only be credited to the client\'s balance after full payment.': 'Для геозони типу «Фініш дозволено» доступні 2 підтипи: Проста та Бонусна. Проста призначена лише для визначення області, у якій можна завершити оренду. Бонусна призначена для автоматичного нарахування бонусів на баланс клієнта в застосунку після завершення поїздки. Важливо: бонус буде нараховано клієнту на баланс лише після повної оплати замовлення.',
  Time: 'Час',
  Timezone: 'Часовий пояс',
  'Time interval (hours)': 'Інтервал часу (годин)',
  'Time of closing': 'Час закриття',
  'Time of operation': 'Час операції',
  'Time period': 'Період часу',
  'The time allocated for verification is coming to an end. To reset the timer and continue checking documents, enter the password again.':
    'Виділений для перевірки час добігає кінця. Щоб скинути таймер і перевірити документи, введіть пароль повторно.',
  'Title image': 'Титульне зображення',
  Today: 'Сьогодні',
  'Toggle fullscreen': 'Увімкнути повноекранний режим',
  Total: 'Всього',
  'Total mileage': 'Загальний пробіг',
  'Total cost (orders)': 'Сумарна відстань',
  'Total distance': 'Сумарна відстань',
  'Total duration': 'Сумарна тривалість',
  'Total order count': 'Всього замовлень',
  'Total price': 'Загальна ціна',
  'Total price (orders)': 'Сумарна вартість замовлень',
  'Total successful order duration': 'Тривалість успішних замовлень',
  'to change the payment terms in the current billing period upon saving the changes, as well as to recalculate the data from the beginning of the billing period to the moment of making changes.':
    'внести зміну умов оплати в поточному розрахунковому періоді за фактом збереження змін, а також провести перерахунок даних з моменту початку розрахункового періоду до моменту внесення змін.',
  'To be able to configure telegram alerts for the notifications created in the system, specify the API key of the telegram bot.':
    'Для отримання можливості налаштування телеграм-повідомлень за створеними повідомленнями в системі, вкажіть API-key телеграм бота.',
  'To gain access to the extended registration document check, you must enter the moderator\'s password. Access will be available for 9 hours from the moment of entering the password. After the time expires, you must re-enter the password to continue the verification.':
    'Щоб отримати доступ до перевірки документів розширеної реєстрації, необхідно ввести пароль модератора. Доступ буде відкритий протягом 9 годин з моменту введення пароля. Після закінчення часу продовження перевірки необхідно ввести пароль повторно.',
  'To have access to check advanced registration documents, user have to enter the moderator password.':
    'Для отримання доступу до перевірки документів розширеної реєстрації користувачеві необхідно ввести пароль модератора.',
  'To highlight the news on the main screen you can add a icon in SVG format measuring 24 x 24 pixels. Adding an icon is not required. You can highlight the news by using emoji in the title.':
    'Щоб виділити новину на головному екрані, ви можете додати іконку розміром 24 x 24 пікселя у форматі SVG. Додавання іконки не є обов\'язковим. Ви можете виділити новину, використовуючи emoji в заголовку.',
  'To automatically populate client, organization, and/or facility information in a document, use the following templates. To quickly copy a template, click it once.': 'Для автоматичного підставлення даних клієнта, організації та/або об’єкта в документ використовуйте наведені нижче шаблони. Щоб швидко скопіювати шаблон, натисніть на нього один раз.',
  Trailers: 'Причепи',
  Trailer: 'Причіп',
  'Trailer price': 'Ціна причепа',
  'Track time': 'Час треку',
  Tracker: 'Трекер',
  'Tracker price': 'Ціна трекера',
  'Tracker charge': 'Заряд трекера',
  Trackers: 'Трекери',
  'IoT modules': 'IoT-модулі',
  'Mechanical bicycles': 'Механічні велосипеди',
  'Electric bicycles (without IoT)': 'Електровелосипеди (без IoT)',
  'Electric bicycles (with IoT)': 'Електровелосипеди (c IoT)',
  'Snow scooters': 'Електроснігокати',
  Trikes: 'Трайки',
  'Tracker connection': 'Підключення трекера',
  'Battery connection': 'Підключення батареї',
  'Monitoring module': 'Модуль моніторингу',
  'Transaction was successfully canceled': 'Транзакцію успішно скасовано',
  Transactions: 'Транзакції',
  'Transactions by bank cards': 'Транзакції по банківській карті',
  'Transaction amount': 'Сума операції',
  'Transaction status': 'Статус операції',
  'Receipt status': 'Статус чека',
  'Translation of push notification after registration': 'Переклад пуш-повідомлення після реєстрації',
  Translations: 'Переклади',
  'Translate into other languages': 'Перекласти на інші мови',
  Transmission: 'Коробка передач',
  'Transferred for temporary use': 'Передано у тимчасове користування',
  'Transfer to access': 'Перевести в доступ',
  'Translation language': 'Мова перекладу',
  Tricycle: 'Трицикл',
  'Tricycle price': 'Ціна трициклу',
  Tricycles: 'Трицикли',
  'Trigger conditions': 'Умови спрацювання',
  Trips: 'Поїздки',
  Trip: 'Поїздка',
  Type: 'Тип',
  'Type registration number': 'Укажіть реєстраційний номер',
  Subtype: 'Підтип',
  'Type of allocation': 'Тип розміщення',
  'Type of transport': 'Тип транспорту',
  'Type of geofence': 'Тип геозони',
  'Unblock device': 'Розбл. пристрій',
  'Unblock engine': 'Розбл. двигун',
  'Unique name': 'Унікальне ім\'я',
  Unit: 'Об\'єкт',
  'Unit address': 'Адреса об\'єкта',
  'Unit coord': 'Координати об\'єкту',
  Hardware: 'Устаткування',
  'Unit billing type': 'Тип білінгу для об\'єкта',
  'Unit commands': 'Команди',
  'Unit images': 'Фотографії об\'єкту',
  'Unit notification log': 'Журнал з об\'єктами',
  'Unit notifications settings': 'Налаштування повідомлень щодо об\'єктів',
  'Unit state': 'Стан об\'єкту',
  'Unit status change': 'Зміна статусу об\'єкта',
  'Unit status': 'Статус об\'єкту',
  'Unit type': 'Тип об\'єкту',
  'Unit model': 'Модель об\'єкту',
  'Unit models': 'Моделі об\'єктів',
  'Unit model groups': 'Групи моделей об\'єктів',
  'Unit replacement': 'Заміна об\'єкта',
  Units: 'Об\'єкти',
  units: 'об\'єктів',
  'Units offline': 'Об\'єкти в автономному режимі',
  'Unit count': 'Кількість об\'єктів',
  'Unit location': 'Розташування об\'єкту',
  'Until the next maintenance, km': 'До наступного ТО, км',
  Unlimited: 'Безліміт',
  unlimited: 'Необмежено',
  'Unknown server error': 'Невідома помилка сервера',
  'Upper bound of the interval': 'Верхня межа інтервалу',
  User: 'Користувач',
  Username: 'Ім’я користувача',
  'User blocked': 'Заблокований',
  'User login': 'Логін користувача',
  'User role': 'Ролі користувача',
  'Custom roles': 'Кастомні ролі',
  'Custom role': 'Кастомна роль',
  'Select custom role': 'Виберіть кастомну роль',
  'Type of role': 'Тип ролі',
  'Select type of role': 'Виберіть тип ролі',
  'Base role': 'Базова роль',
  'Select base role': 'Виберіть базову роль',
  'Automatically enable new features from future releases': 'Автоматично включати нові можливості з майбутніх релізів',
  'User activity log': 'Журнал дій користувачів',
  'Use by default': 'Використовувати за замовчуванням',
  Users: 'Користувачі',
  Usual: 'Звичайний',
  'Valid from': 'Дійсний З',
  'Valid to': 'Дійсний По',
  'Valid until': 'Дійсний до',
  'Validation error': 'Помилка перевірки',
  'Validation error - do you have order? Or order already finished?': 'Помилка перевірки – у вас є замовлення? Або замовлення вже завершено?',
  Value: 'Значення',
  'Value in coins': 'Значення у монетах',
  'Value is too small': 'Значення замале',
  'Invalid characters in promo code': 'Неприпустимі символи в промокоді',
  'Invalid characters in registration number': 'Неприпустимі символи в реєстраційному номері',
  'Invalid coordinate filtering settings': 'Налаштування фільтрації невалідних координат',
  'Please add insurance to price plan': 'Будь ласка, додайте страховку до тарифу',
  'Please configure insurance only once': 'Будь ласка, налаштуйте страховку лише один раз',

  'Please note that this functionality is intended exclusively for the courier business model. When leaving the speed limit geofence, the speed limit disable command set for the hardware model will be sent to the devices, unless a different command is specified in the location region settings for that hardware model.': 'Звертаємо вашу увагу, що цей функціонал призначений виключно для бізнес‑моделі кур’єрського типу. Під час виїзду з геозони обмеження швидкості на пристрої буде надсилатися команда вимкнення обмеження швидкості, встановлена для моделі обладнання, якщо в налаштуваннях регіону розташування об’єкта для цієї моделі обладнання не вказано іншу команду.',
  'Invalid insurance amount; valid amount is:': 'Вказано некоректну вартість страховки; коректна вартість:',
  'Indicate country and city of birth': 'Вкажіть країну та місто народження',
  Videos: 'Відеофайли',
  'Video link': 'Посилання на відео',
  View: 'Перегляд',
  'View Profile': 'Переглянути профіль',
  'View unit': 'Переглянути об\'єкт',
  Viewed: 'Переглянуто',
  Warehouse: 'Склад',
  'Warehouse number': 'Номер складу',
  'Wait polygon': 'Очікування полігону',
  'Waiting time': 'Час очікування',
  Week: 'Тиждень',
  'Weak signal': 'Слабкий сигнал',
  'We recommend using no more than 35 characters, including spaces to ensure that the title is displayed correctly on various mobile devices':
    'Для коректного відображення заголовка на різних мобільних пристроях рекомендуємо використовувати не більше 35 символів, включаючи пробіли',
  'We recommend using no more than 90 characters, including spaces to ensure that the title is displayed correctly on various mobile devices':
    'Для коректного відображення короткого опису на різних мобільних пристроях рекомендуємо використовувати не більше 90 символів, включаючи пробіли',
  'Write the main content of the news': 'Напишіть текст основного змісту новини',
  'Write a brief description. If a schedule is set for the geofence, we recommend including the geofence\'s operating hours in the description. If you\'re creating a speed limit geofence, also include the maximum speed limit.': 'Напишіть короткий опис. Якщо для геозони встановлено розклад, рекомендуємо вказати в описі час роботи геозони. Якщо ви створюєте геозону обмеження швидкості, зазначте також значення максимальної швидкості.',
  'Write a brief description. If the geopoint matches the geofence logic, we recommend duplicating the information from the geofence logic description.': 'Напишіть короткий опис. Якщо геоточка відповідає логіці геозони, рекомендуємо дублювати інформацію з опису логіки геозони.',
  Width: 'Ширина',
  'Width(mm)': 'Ширина(мм)',
  'Write off': 'Списати',
  'Write-off date': 'Дата списання',
  'Written off': 'Списано',
  'Write-off': 'Списання',
  'Write off property': 'Списати майно',
  Yesterday: 'Вчора',
  admin: 'адмін',
  booked: 'заброньовано',
  'color not set': 'колір не заданий',
  free: 'Вільний',
  Free: 'Вільний',
  gsm: 'GSM',
  'hw_id already exists': 'HW ID вже є в системі',
  integrator: 'інтегратор',
  more: 'детальніше',
  More: 'Детальніше',
  'no address': 'адреса не задана',
  'No new clients awaiting confirmation': 'Немає нових клієнтів, які чекають на підтвердження',
  'not booked': 'не заброньовано',
  'not set': 'не задано',
  'Not found': 'Не знайдено',
  'Normal signal': 'Нормальний сигнал',
  'No customer data': 'Немає даних клієнтів',
  'No data': 'Немає даних',
  role: 'роль',
  Images: 'Зображення',
  'Image size 300x300, in formats .png, .jpg, .jpeg, .svg.': 'Розмір зображення 300x300, у форматах .png, .jpg, .jpeg, .svg.',
  'Payment methods': 'Способи оплати',
  Payment: 'Оплата',
  Selected: 'Обрана',
  Selection: 'Вибір',
  Select: 'Вибрати',
  'Select battery': 'Виберіть батарею',
  'Freeze coordinates': 'Зафіксувати координати об\'єкта',
  'Activate if necessary to freeze coordinates of unit at a certain point. The coordinate input field and unit location on the map will appear after activation.' :
    'Активуйте у разі потреби зафіксувати координати об\'єкта у певній точці. Поле введення кооридинат та відображення розташування об\'єкта на карті з\'явиться після активації.',
  'After reaching the level, upon successful payment and order finishing, the client will be awarded a reward in the form of cashback at a specified percentage of the order value. The specified reward will be credited to the client until the client\'s activity level changes.':
    'Після досягнення рівня при завершенні та успішної оплати замовлень клієнту нараховуватиметься винагорода у вигляді кешбеку за вказаним відсотком вартості замовлення. Вказана винагорода нараховуватиметься клієнту доти, доки рівень активності клієнта не зміниться.',
  'Select date': 'Виберіть дату',
  'Select contact type': 'Виберіть тип контакту',
  'Select trackers': 'Виберіть трекери',
  'Select service type': 'Виберіть послугу',
  'Select source': 'Виберіть джерело',
  'Select calculation method': 'Виберіть метод',
  'Select billing model': 'Виберіть порядок оплати',
  'Select the track building period': 'Виберіть період побудови треку',
  'Select destination type': 'Виберіть тип призначення',
  'Select document format': 'Виберіть формат документа',
  'Select type': 'Виберіть тип',
  'Select fare type': 'Виберіть тип тарифу',
  'Select user': 'Виберіть користувача',
  'Select unit models': 'Виберіть моделі об\'єктів',
  'Select objects': 'Виберіть об\'єкти',
  'Select owner': 'Виберіть власника',
  'Select one option': 'Виберіть один варіант',
  'Select currency': 'Виберіть валюту',
  'Select one default condition': 'Виберіть одну умову за умовчанням',
  'Select testers': 'Виберіть тестувальників',
  'Select subscription type': 'Виберіть тип абонементу',
  'Select regions': 'Виберіть регіони',
  'Select region': 'Виберіть регіон',
  'Select price plans': 'Виберіть тарифи',
  'Select price plan': 'Виберіть тариф',
  'Select operating mode': 'Виберіть режим роботи',
  'Select test clients': 'Виберіть клієнтів-тестувальників',
  'Select translation language': 'Виберіть мову перекладу',
  'Select language': 'Виберіть мову',
  'Select license categories': 'Виберіть категорії прав',
  'Select unit type': 'Виберіть тип об\'єкта',
  'Select unit types': 'Виберіть типи об\'єктів',
  'Select a project': 'Виберіть проект',
  'Select a country': 'Виберіть країну',
  'Select a period': 'Виберіть період',
  'Select period': 'Виберіть період',
  'Select an event': 'Виберіть подію',
  'Select actions': 'Виберіть дії',
  'Select action': 'Виберіть дію',
  'Select state': 'Виберіть стан',
  'Select a command pattern': 'Виберіть шаблон команди',
  'Select a condition': 'Виберіть умову',
  'Select a role': 'Виберіть роль',
  'Select a technician': 'Виберіть техніка',
  'Select a speed limit': 'Виберіть обмеження швидкості',
  'Select section': 'Виберіть розділ',
  'Select group': 'Виберіть групу',
  'Select groups': 'Виберіть групи',
  'Select geofences': 'Виберіть геозони',
  'Select clients': 'Виберіть клієнтів',
  'Select level': 'Виберіть рівень',
  'Select legal entity': 'Виберіть юр. особу',
  'Select branch office': 'Виберіть філію',
  'Select hw type': 'Виберіть тип обладнання',
  'Select lock type': 'Виберіть тип замка',
  'Select battery placement type': 'Виберіть тип розміщення АКБ',
  'Select command': 'Виберіть команду',
  'Select the objects for which the tariff will be available':
    'Виберіть об\'єкти, для яких буде доступний тариф',
  'Select a model': 'Виберіть модель',
  'Select the group of clients for whom you want to activate the subscription':
    'Виберіть групу клієнтів, для яких необхідно активувати абонемент',
  'Select price plans available within the subscription': 'Виберіть тарифи доступні в рамках абонементу',
  'Select the language for which the subscription information translation will be added':
    'Виберіть мову, для якої буде додано переклад інформації про абонемент',
  'Select the language for which the price plan information translation will be added':
    'Виберіть мову, для якої буде додано переклад інформації про тариф',
  'Select the region in which the subscription will be valid. If more than one region is selected, the client will be able to use the subscription in all specified regions.':
    'Виберіть регіон, де буде діяти абонемент. У разі вибору більш ніж одного регіону, клієнт зможе користуватися абонементом у всіх зазначених регіонах.',
  'Subscription type': 'Тип абонементу',
  'Select the type of object for which this subscription will be valid':
    'Виберіть тип об\'єкта, для якого буде діяти цей абонемент',
  'Create subscription': 'Створення абонементу',
  'Create fare': 'Створення тарифного плану',
  'Select the project that will apply this requirement':
    'Виберіть проект, у якому діятиме цей абонемент',
  'Select the project in which notifications will be sent': 'Виберіть проєкт, у якому здійснюватиметься розсилка сповіщень.',
  'Select the country in which notifications will be sent': 'Виберіть країну, у якій здійснюватиметься розсилка сповіщень.',
  'Select the integrator whose clients will receive notifications': 'Виберіть інтегратора, за клієнтами якого здійснюватиметься розсилка сповіщень.',
  'Select the region in which notifications will be sent': 'Виберіть регіон, у якому здійснюватиметься розсилка сповіщень.',
  'Select the country in the project in which this subscription will be valid':
    'Виберіть країну в проекті, в якій діятиме цей абонемент',
  'Select the color to get the color code that you will later use in the client interface functionality.':
    'Виберіть колір для отримання колірного коду, який згодом використовуватиметься у функціоналі клієнтського інтерфейсу.',
  'Select a role. (Administrator or Integrator)': 'Виберіть роль. (Адміністратор або інтегратор)',
  'Select a schedule from the list of schedules you have previously created.': 'Виберіть розклад зі списку раніше створених вами розкладів.',
  'Select the action you intend to take with respect to the user\'s payment terms:':
    'Виберіть дію, яку ви збираєтеся зробити щодо умов оплати користувача:',
  'Select connection method': 'Виберіть метод підключення',
  'Select the battery registration status in the system': 'Виберіть статус реєстрації батареї у системі',
  'Select the status of the registration status in the system': 'Виберіть статус статусу реєстрації в системі',
  'Select the unit to which the tracker connects.': 'Виберіть об\'єкт, до якого підключається трекер.',
  'Select the removable battery that the tracker is connected to.': 'Виберіть знімну батарею, до якої підключається трекер.',
  'Select the project where group of clients is created.': 'Виберіть проект, у якому створюється група клієнтів.',
  'Select the country of the project where group of clients is created.': 'Виберіть країну проекту, де створюється група клієнтів.',
  'Select the region where group of clients is created.': 'Виберіть регіон, де створюється група клієнтів.',
  'Select the owner of group of clients.': 'Виберіть власника групи клієнтів.',
  'Select the clients you want to assign to the group.': 'Виберіть клієнтів, яких потрібно призначити в групу.',
  'Select the group of clients for whom you want to activate the subscription.': 'Виберіть групу клієнтів, для яких потрібно активувати абонемент.',
  'Select enrollment form': 'Виберіть форму зарахування',
  'Select registration form': 'Виберіть форму реєстрації',
  'Select the country code': 'Виберіть код країни',
  'Select authentication method': 'Виберіть спосіб автентифікації',
  'Select a bag': 'Виберіть сумку',
  'Select a time zone': 'Виберіть часовий пояс',
  'Select the project for the news item you are creating': 'Виберіть проект, у якому створюється новина',
  'Select the country for the news item you are creating': 'Виберіть країну, де створюється новина',
  'Select criterion': 'Виберіть критерій',
  'Select the project for the client\'s activity level you are creating':
    'Виберіть проект, для якого створюється рівень активності клієнта',
  'Select the translation language of the client\'s activity level name':
    'Виберіть мову, для якої буде додано переклад назви рівня активності клієнта',
  'Select the project for the conditions you are creating':
    'Виберіть проект, до якого додаються умови досягнення рівня активності клієнта',
  'Select the country for the conditions you are creating':
    'Виберіть країну, для якої додаються умови досягнення рівня активності клієнта',
  'Select the business model for the conditions you are creating':
    'Виберіть бізнес-модель, до якої додаються умови досягнення рівня активності клієнта',
  'Select the client activity level for the achievement conditions you are creating':
    'Виберіть рівень активності клієнта, до якого додаються умови досягнення',
  'Select the project for the component model you are creating': 'Виберіть проект, у якому створюється модель комплектуючого',
  'Select the project for the branch you are creating': 'Виберіть проект, у якому створюється філія',
  'Select the country for the branch you are creating': 'Виберіть країну, де створюється філія',
  'Select the project for the Legal Entity you are creating': 'Виберіть проект, у якому створюється юридична особа',
  'Select the country for the Legal Entity you are creating': 'Виберіть країну, в якій створюється юридична особа',
  'Select the hardware type that matches your device. The port the device should be pointed to is shown in brackets. If you can\'t find the right hardware type or need any other assistance setting up your device connection, please contact technical support.': 'Виберіть тип обладнання, що відповідає вашому пристрою. У дужках відображається порт, на який має бути спрямований девайс. Якщо ви не можете знайти відповідний тип обладнання або вам потрібна будь‑яка інша допомога з налаштування підключення вашого пристрою, зверніться до служби технічної підтримки.',
  'Select owner of the Legal Entity you are creating': 'Виберіть власника юридичної особи',
  'Select owner of the branch you are creating': 'Виберіть власника філії',
  'Select unit type for the hardware model you are creating': 'Виберіть тип об’єкта, для якого створюється модель обладнання',
  'Select the speed limit disable command': 'Виберіть команду вимкнення обмеження швидкості',
  'Select the days of the week for your schedule': 'Виберіть дні тижня роботи розкладу.',
  'Select region of the branch you are creating': 'Виберіть регіон, де створюється філія',
  'Select the project for the component type you are creating': 'Виберіть проект, у якому створюється тип комплектуючого',
  'Select the hardware model for which the speed limit command is being added': 'Виберіть модель обладнання, для якої додається команда обмеження швидкості',
  'Select the speed limit command according to the selected hardware model': 'Виберіть команду обмеження швидкості відповідно до вибраної моделі обладнання',
  'Select the business-model for the geofence you are creating': 'Виберіть бізнес-модель, для якої створюється геозона',
  'Select the type of movement': 'Виберіть тип руху',
  'Select employment type': 'Виберіть тип зайнятості',
  'Select couriers': 'Виберіть кур\'єрів',
  'Select a courier': 'Виберіть кур\'єра',
  'Courier identification': 'Ідентифікація кур\'єра',
  'Select courier identification': 'Виберіть спосіб ідентифікації кур\'єра',
  'External id of the courier': 'Зовнішній ідентифікатор кур\'єра',
  'Select an assignment method': 'Виберіть метод призначення',
  'Select form type': 'Виберіть тип форми',
  'Select document type': 'Виберіть тип документа',
  'Select the document addition method': 'Виберіть метод додавання документа',
  'Specify group name. For example, LLC Delivery3000.': 'Вкажіть назву групи клієнтів. Наприклад, ТОВ "Доставка 3000".',
  'Enter custom group name description.': 'Введіть довільний опис групи клієнтів.',
  'Subscription period already selected': 'Вибраний період дії абонементу вже додано',
  'Subscription terms': 'Умови абонементу',
  'Subscription price is indicated for each validity period': 'Вартість абонементу вказується для кожного періоду дії',
  'subscription-fee-amount-value': 'Вартість',
  'Subscription purchases': 'Покупки абонементів',
  Number: 'Номер',
  News: 'Новини',
  'Number of trips': 'Кількість поїздок',
  'Number of trips (-1 - Unlimited)': 'Кількість поїздок (-1 – Необмежено)',
  'Add date': 'Дата додавання',
  'No bank cards': 'Немає банківських карток',
  'Not issued': 'Не оформлений',
  'Clone hardware model': 'Копіювати модель обладнання',
  'Clone price plan': 'Копіювати тарифний план',
  'Clone subscription': 'Копіювати абонемент',
  Active: 'Активний',
  'active-orders': 'Активні',
  Disabled: 'Не активний',
  'Ride allow': 'Їздити дозволено',
  'Ride restrict': 'Їздити заборонено',
  'Finish allow': 'Фініш дозволений',
  'Finish restrict': 'Фініш заборонений',
  'Riding allowed': 'Їздити дозволено',
  'Riding prohibited': 'Їздити заборонено',
  'Right to edit': 'Право на редагування',
  'Parking allowed': 'Паркування дозволено',
  'Parking prohibited': 'Паркування заборонено',
  'Geofences and geopoints': 'Геозони та геоточки',
  'Age limit': 'Вікове обмеження',
  'Has mechanical lock code': 'Код механічного замку вказано',
  'Hasn\'t mechanical lock code': 'Код механічного замку не вказано',
  'Mechanical lock status': 'Статус механічного замку',
  'Hasn\'t mechanical lock': 'Не має механічного замку',
  'Steering wheel': 'Рульове колесо',
  Accelerator: 'Газ',
  Brake: 'Гальмо',
  Wheels: 'Колеса',
  'When copying a tariff, you must specify which type of tariff the new one will belong to. In case of creating an analogue of the basic tariff to provide it within the framework of the subscription, select "Subscription". Otherwise - select "Basic"':
    'При копіюванні тарифу необхідно вказати якого типу тарифу буде відноситися новий. У разі створення аналога базового тарифу, для його надання в рамках абонементу виберіть "Абонемент". В іншому випадку - виберіть "Базовий"',
  'When you select the Activation for a group of clients destination of the subscription, in the appeared field you\'ll need to select a group of clients for whom the subscription will be automatically activated upon turning on the subscription by the user. When you select the Purchase by client destination of the subscription, it will be available for purchase to all clients in the specified region.':
    'При виборі призначення абонемета Активація для групи клієнтів, з\'явиться поле вибору групи клієнтів, для яких абонемент автоматично активується за фактом включення абонементу користувачем. При виборі призначення абонементу Купівля клієнтом, абонемент буде доступним для покупки всім клієнтам у вказаному регіоні.',
  'When the rental office is closed, the services provided will not be available for requests in the mobile app for couriers.':
    'При закритті офісу прокату послуги, що надаються, будуть недоступні для заявок у мобільному додатку для кур\'єрів.',

  'When creating an IoT module, its registration number is generated automatically based on the prefix of the hardware manufacturer specified in the hardware model and the numerical part specified in the corresponding field of the IoT module creation form.': 'Під час створення IoT-модуля його реєстраційний номер генерується автоматично на основі префікса виробника обладнання, зазначеного в моделі обладнання, та числової частини, вказаної у відповідному полі форми створення IoT-модуля.',
  'When choosing a fixed amount, the client will receive the specified amount upon completion of the trip, regardless of the order cost. With cashback, the customer will receive a specified percentage of the order cost. Important: If the fare already specifies a cashback percentage, the bonuses will not be combined. The system will automatically select the percentage in favor of the client.balance upon completion of the trip. Important: the bonus will only be credited to the client\'s balance after full payment.': 'Під час вибору фіксованої суми після завершення поїздки клієнту буде нараховано вказану суму незалежно від вартості замовлення. У випадку кешбеку клієнту буде нараховано вказаний відсоток від вартості замовлення. Важливо: якщо в тарифі вже зазначено відсоток кешбеку, бонуси не підсумовуються. Значення відсотка система автоматично вибере на користь клієнта.',
  'What are we creating?': 'Що творимо?',
  Footboard: 'Підніжка',
  Rack: 'Рама',
  Battery: 'Батарея',
  'Basic data': 'Основні дані',
  'Basic rates': 'Базові тарифи',
  Basic: 'Базові',
  'Basic price plans': 'Базові тарифи',
  Other: 'Інше',
  'Operating mode': 'Режим роботи',
  'Operation details': 'Деталі операції',
  'Operation history': 'Історія операції',
  'Operating system and version': 'Операційна система та її версія',
  'Broke parts': 'Зламані частини',
  'Public ID': 'Публічний ID',
  'Charge start/finish': 'Заряд старт/фініш',
  Booked: 'Заброньований',
  Pause: 'Пауза',
  km: 'км',
  'km ago': 'км назад',
  'km/h': 'км/год',
  'Total cost': 'Загальна вартість',
  Fine: 'Штраф',
  Fines: 'Штрафи',
  'Issue a fine': 'Виписати штраф',
  'Order history': 'Історія замовлень',
  'Order photos': 'Фотографії замовлення',
  Copy: 'Копіювати',
  Copying: 'Копіювання',
  Combat: 'Бойовий',
  day: 'день',
  minute: 'хвилина',
  hour: 'година',
  hours: 'годин',
  hour_: 'годин',
  'Holding error': 'Помилка холдування',
  Pay: 'Оплатити',
  'Pay debt': 'Сплатити заборгованість',
  'Pay using CloudPayments': 'Оплатити через Cloud',
  'Not paid': 'Не оплачений',
  Paid: 'Оплачний',
  'Paid up': 'Оплачено',
  'Number Prefix': 'Префікс Номера',
  'Vendor prefix': 'Префікс виробника обладнання',
  'Account ID': 'Обліковий запис',
  Success: 'Успішно',
  'Order successfully paid': 'Замовлення успішно оплачено',
  Enabled: 'Активний',
  'Entity address': 'Юр. адреса',
  'Entity phone': 'Юр. телефон',
  'Entity settlement account': 'Розрахунковий рахунок',
  'Type of entity': 'Тип організації',
  Test: 'Тестовий',
  Testers: 'Тестувальники',
  'Test GPRS/Test connection': 'Тест GPRS/Тест підключення',
  'Connected to server': 'Підключено до сервера',
  'Enable unit grouping': 'Увімкнути групування об\'єктів',
  'Disable unit grouping': 'Вимкнути угруповання об\'єктів',
  Low: 'Низький',
  Medium: 'Середній',
  High: 'Високий',
  'Without broken parts': 'Без зламаних частин',
  'Please wait': 'Будь ласка, зачекайте',
  'No messages found': 'Повідомлень не знайдено',
  MIR: 'МИР',
  'Unit registration number': 'Реєстраційний номер об\'єкту',
  'Units visibility': 'Видимость объектов',
  Headline: 'Заголовок',
  'Head: no information': 'Голова: немає інформації',
  'Head: is on': 'Голова: увімкнена',
  'Head: is off': 'Голова: вимкнена',
  'Heat map': 'Теплова карта',
  'Brake: no information': 'Гальма: немає інформації',
  'Brake: OFF': 'Гальма: вимкнені',
  'Brake: ON': 'Гальма: увімкнені',
  'Speed mode: drive': 'Швидкісний режим: drive',
  'Speed mode: eco': 'Швидкісний режим: eco',
  'Speed mode: speed': 'Швидкісний режим: speed',
  'Speed mode: no information': 'Швидкісний режим: немає інформації',
  'Specify the priority': 'Вкажіть пріоритет',
  'Specify the reason': 'Вкажіть причину',
  'Specify purpose': 'Вкажіть призначення',
  'Specify the region boundaries': 'Вкажіть межі регіону',
  'Specify the geopoint location': 'Вкажіть місцезнаходження геоточки',
  'Specify the geofence boundaries': 'Вкажіть межі геозони',
  'Specify validity period': 'Вкажіть період дії',
  'Specifies the maximum battery charge of the object, at which the tariff can be displayed in the mobile application for the object.':
    'Вказується максимальний заряд АКБ об\'єкта, за якого можна відображати тариф у мобільному додатку для об\'єкта.',
  'Specify object models for which the tariff will be available.':
    'Вкажіть моделі об\'єктів, для яких буде доступний тариф.',
  'Specifies the user-owner of the objects for which the tariff will be available':
    'Вказується користувач-власник об\'єктів, для яких буде доступний тариф',
  'Specify the cost': 'Вкажіть вартість',
  'Specify an increasing cycle time': 'Вкажіть сумарну тривалість оренди',
  'Specifies the total duration of the lease in minutes. It is from this value that the travel time will be deducted.':
    'Вказується сумарна тривалість оренди в хвилинах. Саме від цього значення буде списуватися час поїздок.',
  'Specify the days of the week on which this tariff will be available. You can select all days of the week, weekdays weekends, or a specific day of the week.':
    'Вказуються дні тижня, в які буде доступний даний тариф. Можна обрати всі дні тижня, робочі дні, вихідні дні або конкретний день тижня.',
  'Specify the project in which the object will work':
    'Вкажіть проект, у якому працюватиме об\'єкт',
  'Specify the service delivery region for the object. As long as the object\'s service delivery region does not match the object\'s current location, the region name will be outlined in red.':
    'Вкажіть регіон надання послуг для цього об\'єкта. Поки регіон надання послуг об\'єкта не збігається з поточним розташуванням об\'єкта, назва регіону матиме червоний контур.',
  'Specify the object model. The object model is displayed in the client interface in the object card. Depending on the selected model, the functionality may differ.':
    'Вкажіть модель об\'єкта. Модель об\'єкта відображається в інтерфейсі клієнта у картці об\'єкта. Залежно від вибраної моделі функціональні можливості можуть відрізнятися.',
  'Service mode: is on': 'Сервісний режим: увімкнено',
  'Specify the daily time interval during which the tariff will be available for the selected day of the week.':
    'Вкажіть добовий інтервал часу, в який буде доступний тариф за вибраним днем тижня.',
  'Specify mileage': 'Вкажіть пробіг',
  'Specify seconds': 'Вкажіть секунди',
  'Specify cost': 'Вкажіть вартість',
  'Specify the IMEI of the telematics equipment installed in your facility. Equipment communication with the server depends on the correctness of the specified IMEI. It is recommended to check the correctness of the entered data several times.':
    'Вкажіть IMEI телематичного обладнання, встановленого у вашому об\'єкті. Від коректності зазначеного IMEI залежить зв\'язок обладнання із сервером. Рекомендується кілька разів перевірити коректність введених даних.',
  'Specify the current mileage of the object. This value will be used to calculate the mileage of the object. ':
    'Вкажіть поточний пробіг об\'єкта. Від вказаного значення буде вестися відлік пробігу об\'єкта. ',
  'Specify the model of telematics equipment installed in your facility. Depending on the selected model of equipment, the correct operation of message reception, sending commands and functional features of the equipment depends on it.':
    'Вкажіть модель телематичного обладнання, встановленого у вашому об\'єкті. Залежно від обраної моделі обладнання залежить коректність роботи прийому повідомлень, надсилання команд та функціональних особливостей обладнання.',
  'Specify the integrator to whom the facility is leased.': 'Вкажіть інтегратора, якому здійснюється передача об\'єкта в оренду.',
  'Specify the code of the mechanical lock. It is recommended to change the mechanical lock code as often as possible.':
    'Вкажіть код механічного замка. Рекомендується якнайчастіше змінювати код механічного замку.',
  'Specify the billing model of payment for services.': 'Вкажіть порядок оплати надання послуг платформи.',
  'Specify the amount of negative balance, upon reaching which, the user\'s units will be blocked.':
    'Вкажіть максимальну суму негативного балансу, при досягненні якої, об\'єкти користувача будуть заблоковані.',
  'Specify the minimum balance amount at which the partner\'s units will be blocked. A negative value can be specified.':
    'Вкажіть мінімальну суму балансу, при досягненні якої об\'єкти користувача будуть заблоковані. Можна вказати негативне значення.',

  'Specify the minimum number of satellites required for coordinates to be considered valid. Filtering is only applied to online messages to prevent outliers and to pin the unit on the map using the latest valid coordinates. The actual coordinates sent by the equipment are saved in the message history.': 'Вкажіть мінімальну кількість супутників, за якої координати вважатимуться валідними. Фільтрація застосовується лише до онлайн‑повідомлень, щоб запобігти викидам і фіксувати об’єкт на карті за останніми валідними координатами. В історії повідомлень зберігаються фактичні координати, надіслані обладнанням.',
  'Hidden units': 'Приховані об\'єкти',
  'Payment deadline': 'Крайній термін оплати',
  'Specify the currency of payment for the platform services.':
    'Вкажіть валюту, в якій будуть вестись розрахунки за надання послуг платформи.',
  'Specify the billing period for which payment will be charged.':
    'Вкажіть період розрахунків, за який стягуватиметься оплата.',
  'Specify the number of days in the calculation period.':
    'Вкажіть кількість днів у періоді розрахунків.',
  'Specify the calculation method for the billing period. The "Units" method means that user pays only for those units that had the status "Available" at least once during the billing period. The "Interest" method means that user pays only the % of revenue or paid order value depending on the choice. The "Access Fee" method means that user pays only a fixed fee for the billing period. The "Combined" method may consist of units calculation as well as access fee calculation and the other combinations of calculation methods.':
    'Вкажіть метод, за яким будуть проводитись розрахунки за надання послуг платформи. У разі вибору методу розрахунків по об\'єктах розрахунок здійснюватиметься виходячи із зазначеної ціни об\'єкта, переведеного у статус «Доступний». У разі вибору методу розрахунків за відсотком розрахунок здійснюватиметься виходячи із зазначеного відсотка або від виручки або від сплаченої вартості замовлень за розрахунковий період. У разі вибору методу розрахунку за абонентською платою розрахунок здійснюватиметься виходячи із зазначеної суми абонентської плати розрахункового періоду. У разі вибору методу розрахунку Комбінований доступна можливість вибрати кілька варіантів розрахунку: об\'єкти, відсоток, абонентська плата.',
  'Specify the value of interest which will be deducted from the source.':
    'Вкажіть відсоток, який буде стягуватися з джерела.',
  'Specify the source of deduction of interest: Revenue or Order Cost. The source "Order Cost" means that the user pay the interest of paid order value.':
    'Вкажіть джерело зняття відсотка за надання послуги: "Виторг" або "Вартість замовлень". При виборі джерела "Вартість замовлень" відсоток стягуватиметься лише від сплаченої вартості замовлень.',
  'Specify the access fee value for the billing period.':
    'Вкажіть вартість абонентської плати за встановлений розрахунковий період.',
  'Specify price of the unit.':
    'Вкажіть ціну одиниці що тарифікується, яка стягуватиметься з кожного об\'єкта один раз у зазначений розрахунковий період. Оплата стягується лише за об\'єкт, переведений у статус "Доступний"',
  'Specify calculated service type of the combined calculation method: Units, Interest or Access Fee.':
    'Вкажіть тарифіковану послугу комбінованого методу розрахунку: Об\'єкти, Відсоток або Абонентська плата.',
  'Specify the account login in Latin letters without spaces':
    'Вкажіть логін облікового запису для входу в систему латинськими літерами без пробілів',
  'Specify the user account password for logging in':
    'Вкажіть пароль облікового запису користувача для входу до системи',
  'Specify the user\'s email to be able to recover the password':
    'Вкажіть email користувача для можливості відновлення пароля',
  'Specify the user who owns the account': 'Вкажіть користувача-власника облікового запису',
  'Specify the position of the contact person who has access to the user account':
    'Вкажіть посаду контактної особи, яка має доступ до облікового запису користувача',
  'Specify the Telegram username of the contact person who has access to the user account.':
    'Вкажіть ім\'я користувача контактної особи в Telegram, яка має доступ до облікового запису користувача.',
  'Specify a link to the group of the corresponding organization in Telegram in the format https://t.me/BF_news1':
    'Вкажіть посилання на групу відповідної організації в Telegram у форматі https://t.me/BF_news1',
  'Specify the regions where the user works.': 'Вкажіть регіони, в яких працює користувач.',
  'Specify the access rights to the rate functionality the user should have':
    'Вкажіть які права доступу до функціоналу тарифів повинен мати користувач',
  'Specify the access rights to the subscription functionality the user should have':
    'Вкажіть які права доступу до функціоналу абонементів повинен мати користувач',
  'Specify the acquiring, which will be used for transactions with bank cards to pay for the orders and other purchases.':
    'Вкажіть еквайринг, за яким будуть здійснюватися операції з банківських карток для оплати замовлень та інших покупок.',
  'Specify the payment service through which the purchase of bonus packages, subscriptions and routes will be available.':
    'Вкажіть сервіси купівлі, за яким буде доступна купівля бонусних пакетів, абонементів, маршрутів.',
  'Specify the user ID (identifier) in the SimManager system to obtain information about the balance of SIM cards.':
    'Вкажіть ID (ідентифікатор) користувача в системі SimManager для отримання інформації про баланс сім-карток.',
  'Specify the acquiring to which funds will be received when replenishing the balance of a user (integrator, administrator) through the admin panel':
    'Вкажіть еквайринг, на який надходитимуть кошти при поповненні балансу користувача (інтегратора, адміністратора) через панель адміністратора',
  'Specify the reason for closing the alarm': 'Вкажіть причину закриття тривоги',
  'Specify the reason for closing all alarms': 'Вкажіть причину закриття всіх тривог',
  'Specify the reason for the deviation': 'Вкажіть причину відхилення',
  'Specify the regions in which the news item should be displayed': 'Вкажіть регіони, в яких має відображатись новина',
  'Specify the geofence owner. The geofence owner, as well as their child users with editing permissions, will be able to edit and delete the geofence.': 'Вкажіть власника геозони. Власник геозони, а також його дочірні користувачі з правами на редагування, зможуть редагувати та видаляти геозону.',
  'Specify the language in which the news should be displayed if there is no translation corresponding to the language of the client\'s device.':
    'Вкажіть якою мовою необхідно відображати новину, у разі відсутності перекладу, що відповідає мові пристрою клієнта.',
  'Specify the ordinal number of the client\'s activity level achievement': 'Вкажіть порядковий номер досягнення рівня активності клієнта',
  'Specify the ordinal number': 'Вкажіть порядковий номер',
  'Specify the language in which the notification should be sent if there is no translation corresponding to the language of the client\'s device.':
    'Вкажіть якою мовою необхідно надсилати повідомлення, у разі відсутності перекладу, що відповідає мові пристрою клієнта.',
  'Specify the language in which level name should be displayed if there is no translation corresponding to the language of the client\'s device.':
    'Вкажіть якою мовою необхідно відображати назву рівня, у разі відсутності перекладу, що відповідає мові пристрою клієнта.',
  'Specify the reason for write-off': 'Вкажіть причину списання',
  'Specify the unit type(-s) to which the component model belongs':
    'Вкажіть тип(и) об\'єкта, якому належить модель комплектуючого.',
  'Specify the unit model(-s) to which the component model belongs': 'Вкажіть модель(-и) об\'єкта, до якої належить модель комплектуючого.',
  'Specify the time zone of the region you are creating': 'Вкажіть часовий пояс регіону, який ви створюєте',
  'Specify the period of time for the schedule to operate for the specified days of the week within a day.': 'Вкажіть період часу роботи розкладу для зазначених днів тижня в межах доби.',
  'Specify the geopoint owner. The geopoint owner, as well as their child users with editing permissions, will be able to edit and delete the geopoint.': 'Вкажіть власника геоточки. Власник геоточки, а також його дочірні користувачі з правами на редагування, зможуть редагувати та видаляти геоточку.',
  'Specify the language in which the information for the client should be displayed if there is no translation matching the client device language.': 'Вкажіть, якою мовою необхідно відображати інформацію для клієнта у разі відсутності перекладу, що відповідає мові пристрою клієнта.',
  'Specify value': 'Введіть значення',
  'Service mode: is off': 'Сервісний режим: вимкнено',
  'Service mode: no information': 'Сервісний режим: немає інформації',
  'Lock: is closed': 'Замок: закритий',
  'Language not selected': 'Мова не обрана',
  'Lock: is opened': 'Замок: відкритий',
  Opened: 'Відкритий',
  'Lock: no information': 'Замок: немає інформації',
  'Flashlight: is on': 'Ліхтарик: увімкнений',
  'Flashlight: is off': 'Ліхтарик: вимкнений',
  'Flashlight: no information': 'Ліхтарик: немає інформації',
  'Height unknown': 'Висота невідома',
  Height: 'Висота',
  'Height(mm)': 'Висота(мм)',
  Organization: 'Організація',
  'Organization name': 'Назва організації',
  'Taxpayer identification number': 'Ідентифікаційний номер платника податків',
  'Enter taxpayer identification number': 'Введіть ідентифікаційний номер платника податків',
  'Select an organization': 'Виберіть організацію',
  'Select an icon': 'Виберіть іконку',
  'Select an available icon from the icon library': 'Виберіть доступну іконку з бібліотеки іконок.',
  'd.': 'д.',
  'm.': 'ь.',
  'h.': 'г.',
  'h. ago': 'г. тому',
  's.': 'с.',
  'Last message time': 'Час останнього повідомлення',
  ago: 'тому',
  'Last message time unknown': 'Час останнього повідомлення невідомий',
  'Add acceptance certificate': 'Додати акт прийому',
  'Acceptance certificates': 'Акти прийому',
  Template: 'Шаблон',
  TIN: 'ІПН',
  'Title not selected': 'Назва не вибрана',
  'You can use the templates above to automatically replace in this text':
    'Ви можете використовувати шаблони вище для автоматичної заміни цього тексту',
  'You have new booking': 'Ви маєте нове бронювання',
  'You can change the subscription for a group, in which case the current subscription is deactivated, and the new subscription is activated for all clients of the group.':
    'Ви можете змінити абонемент для групи, при цьому діючий абонемент деактивується, а новий абонемент активується для всіх клієнтів групи.',
  'You can assign a previously created schedule if it\'s suitable, or create a new one. The new schedule will be available in your list for future assignments or adjustments.': 'Ви можете призначити раніше створений вами розклад, якщо він підходить, або створити новий. Новий розклад буде доступний у вашому списку для подальших призначень або коригування.',
  'You can add icons in PNG or SVG formats with a 1:1 aspect ratio. Recommended icon sizes are 24 x 24 pixels for SVG and 64 x 64 pixels for PNG. The maximum file size is 15 KB.': 'Доступна можливість додати іконку у форматах PNG або SVG зі співвідношенням сторін 1:1. Рекомендовані розміри іконок: 24 x 24 пікселі для SVG і 64 x 64 пікселі для PNG. Максимальний розмір файлу — 15 КБ.',
  'You can immediately select geofences from the list to which the schedule will apply. You can also assign a created schedule when creating a geofence.': 'Ви можете одразу вибрати геозони зі списку, на які поширюватиметься розклад. Також ви можете призначити створений розклад під час створення геозони.',
  'You can immediately select the tariffs from the list to which the schedule will apply. You can also assign the created schedule when creating the tariff.': 'Ви можете одразу вибрати тарифи зі списку, на які поширюватиметься розклад. Також ви можете призначити створений розклад під час створення тарифу.',
  Text: 'Текст',
  'Patterns for set and replace': 'Шаблони для підстанови та заміни',
  'Unit model name': 'Назва моделі об\'єкта',
  'Integrator Organization name': 'Назва Організації інтегратора',
  'Integrator can edit data on the object, as well as delete the object':
    'Інтегратор може редагувати дані щодо об\'єкта, а також видалити об\'єкт',
  'Scooter registration number': 'Реєстраційний номер самокату',
  'Client phone number': 'Номер телефону клієнта',
  'Client\'s full name': 'ФІО клієнта',
  Created: 'Створений',
  'Electric bikes': 'Ел. велосипеди',
  'Electric scooter': 'Ел. самокат',
  'Electric scooters': 'Ел. самокати',
  'Electric quad bikes': 'Ел. квадроцикли',
  'Electric-bikes': 'Ел. велосипеди',
  'Electric quad bike': 'Ел. квадроцикл',
  'Electric quad bike price': 'Ціна ел. квадроцикла',
  'Electric scooter price': 'Ціна ел. самокату',
  'Each geofence type has its own logic and corresponding color. Detailed information on each geofence type and its logic is available in the project documentation. To access the documentation, please contact the project support team.': 'Кожен тип геозони має свою логіку та відповідний колір. Детальна інформація про кожен тип геозони та логіку роботи доступна в документації проєкту. Щоб отримати доступ до документації, зверніться до служби підтримки проєкту.',
  Apartment: 'Квартира',
  Station: 'Станція',
  'Station price': 'Ціна станції',
  Starts: 'Старти',
  'Is used': 'Використовується',
  'Click to change state': 'Натисніть, щоб змінити стан',
  'Acceptance certificate state successfully changed': 'Стан акту прийому успішно змінено',
  'Are sure you want to delete this acceptance certificate': 'Дійсно видалити цей акт прийому',
  'Are sure you want to delete this language': 'Дійсно видалити цю мову',
  'Successfully deleted': 'Успішно видалений',
  'Delete failed': 'Видалити не вдалося',
  'Go Back': 'Назад',
  'Go to': 'Перейти',
  'Good signal': 'Хороший сигнал',
  'Google API-key not valid': 'Google API-key недійсний',
  'Google Maps Settings': 'Налаштування Google Maps',
  'Download application link': 'Посилання для завантаження програми',
  Debt: 'Заборгованість',
  Decrease: 'Зменшення',
  'Debt / Fines': 'Заборгованість / Штрафи',
  'Day of the week not selected': 'День тижня не обраний',
  'Debt currency': 'Валюта заборгованості',
  'Debt repayments': 'Списання',
  'Debt repayments from': 'Списання заборгованості від',
  'Search by LBS': 'Знайти по LBS',
  Search: 'Пошук',
  'Search for': 'Шукати',
  'Search by name': 'Пошук за назвою',
  precision: 'Точність',
  'LBS coordinates': 'Координати по LBS',
  'Cancel debt': 'Скасувати заборгованість',
  Cancel: 'Скасувати',
  Cancellation: 'Відміна',
  'Cancel insurance': 'Анулювати страхування',
  'Are sure you want to cancel insurance': 'Дійсно хочете анулювати страхування',
  'Insurance successfully canceled': 'Страхування успішно анульоване',
  'An error occurred while trying to cancel insurance': 'При спробі анулювання страхування виникла помилка',
  'Error in price plan': 'Помилка у тарифі',
  'Insurance payment error': 'Помилка оплати страховки',
  Min: 'Хв.',
  min: 'хв.',
  Minutes: 'Хвилини.',
  Max: 'Макс.',
  'less than 5 minutes': 'менше 5 хвилин',
  '5 to 15 minutes': 'від 5 до 15 хвилин',
  '15 to 30 minutes': 'від 15 до 30 хвилин',
  'more than 30 minutes': 'більше 30 хвилин',
  '80% to 100%': 'від 80% до 100%',
  '50% to 79%': 'від 50% до 79%',
  '20% to 49%': 'від 20% до 49%',
  'Max debt amount': 'Максимальна сума заборгованості',
  'Minimum balance': 'Мімімальний баланс',
  'The main screen of the app displays only three recent unread news items. You can pin an important news item to display it on the main screen every time the app is launched, regardless of whether it has been read/hidden by the client or not. We do not recommend pinning more than one news item.':
    'На головному екрані програми відображається не більше трьох останніх непрочитаних новин. Ви можете закріпити важливу новину, щоб відображати її на головному екрані при кожному запуску програми, незалежно від того, чи вона була прочитана / прихована клієнтом, чи ні. Ми не рекомендуємо закріплювати більше однієї новини.',
  'Maximum duration of the trip': 'Макс. тривалість поїздки',
  'Maximum duration of the trip (-1 - no limits)': 'Макс. тривалість поїздки (-1 - без обмежень)',
  'Debt canceled successfully': 'Заборгованість успішно скасована',
  'Debt successfully paid': 'Заборгованість успішно сплачена',
  'Remaining number of uses': 'Кількість використань, що залишилися',
  'LBS search': 'Пошук по LBS',
  'Not enough data to search for LBS': 'Недостатньо даних для пошуку по LBS',
  'Units count': 'Кількість об\'єктів',
  'Units active count by period': 'Кількість активних об\'єктів за період',
  'Units event log': 'Журнал подій об\'єктів',
  'Amount for period by active units': 'Сума за період по активних об\'єктах',
  'Fixed amount': 'Фіксована сума',
  Messages: 'Повідомлення',
  Latitude: 'Широта',
  'Latest photos': 'Останні фото',
  Longitude: 'Довгота',
  Parameters: 'Параметри',
  'Parent account blocked': 'Заблокирован родитель',
  Course: 'Курс',
  'Report by users': 'Звіт по користувачам',
  'Representative\'s name': 'Ім\'я представника',
  'Data collection time': 'Час збору даних',
  'Date and time of connection': 'Дата та час підключення',
  From: 'З',
  To: 'До',
  'Number days in minus': 'Кількість днів в мінус',
  'Number of days': 'Кількість днів',
  'Active units amount': 'Сума за активні об\'єкти',
  'All units amount': 'Сума за всі об\'єкти',
  'Chat in whatsapp': 'Написати в whatsapp',
  'Journal orders': 'Журнал замовлень',
  'User id': 'id користувача',
  'Time start': 'Час початку',
  'Store ID': 'Ідентифікатор магазину',
  'Last Order Finish Time': 'Час останнього замовлення',
  'Secret Key': 'Секретний ключ',
  'Security mode': 'Охоронний режим',
  'Security mode: is on': 'Охоронний режим: увімкнено',
  'Security mode: is off': 'Охоронний режим: вимкнено',
  'Security mode: no information': 'Охоронний режим: немає інформації',
  'Public Key': 'Публічний ключ',
  'Technical area': 'Технічна зона',
  'Technics territories': 'Територіі техніка',
  'Technics territory': 'Територія техніка',
  Technicians: 'Техніки',
  Technician: 'Технік',
  'Balance in coins': 'Баланс у монетах',
  'Balance in currency': 'Баланс у валюті',
  'On Charge': 'На зарядці',
  Alarm: 'Тривога',
  'On Charge At Stock': 'На зарядці на складі',
  'Not Available': 'Не доступний',
  Stolen: 'Вкрадений',
  'Under Repair': 'В ремонті',
  Donor: 'Донор',
  'Not set': 'Не заданий',
  'SIM cards balance': 'Баланс SIM-карт',
  'User balance': 'Баланс користувача',
  'Balance report': 'Історія балансу',
  'Balance report 2023': 'Історія балансу 2023',
  'Paid message log': 'Журнал платних повідомлень',
  'Close all': 'Закрити все',
  'Close all alarms': 'Закрити всі тривоги',
  'Description details': 'Подробиці опису',
  Routes: 'Маршрути',
  Purchases: 'Покупки',
  'Purchase by client': 'Покупка клієнтом',
  'Purchase log': 'Журнал покупок',
  'End user': 'Клієнт',
  'End of billing period': 'Закінчення розрахункового періоду',
  Ending: 'Закінчення',
  'Only a user with the administrator role can be the project owner': 'Власником проекту може бути лише користувач за участю адміністратор',
  'Only administrator or integrator can be the owner of the news item.':
    'Власником новини може бути або адміністратор, або інтегратор',
  'Free-form project name': 'Назва проекту у довільній формі',
  'The unique identifier is used to bind the mobile app to the project. It\'s the name of the project, written in small Latin letters without spaces or special characters. IMPORTANT!!! Once the project is created, the unique identifier cannot be changed!':
    'Унікальний ідентифікатор призначений для зв\'язку проекту з мобільним додатком. Являє собою назву проекту, написану маленькими латинськими літерами без прогалин та спецсимволів. ВАЖЛИВО! Після створення проекту унікальний ідентифікатор неможливо змінити!',
  'Simple registration contains a basic information about the client and doesn\'t require document verification. Extended registration contains supporting documents that are sent for moderation to the project administrator and/or project manager with moderator functionality.': 'Проста реєстрація містить мінімум інформації про клієнта та не вимагає перевірки документів. Розширена реєстрація містить документи, що підтверджують, які відправляються на модерацію адміністратору проекту та/або менеджеру проекту з функціоналом модератора.',
  'The extended registration type determines the set of supporting documents. Detailed information is available in the platform documentation.':
    'Розширений тип реєстрації визначає набір документів, що підтверджують. Детальна інформація доступна у документації платформи.',
  'One-time password is valid for only one authentication session and is provided to the client by one of the available sources. A reusable password is created when registering a client account and its use for authentication is unlimited.'
    : 'Одноразовий пароль дійсний лише для одного сеансу автентифікації та надається клієнту одним із доступних джерел. Багаторазовий пароль створюється під час реєстрації облікового запису клієнта, і його використання для автентифікації необмежено.',
  'Specify the sources of provision of one-time password to the client.':
    'Вкажіть джерело надання одноразового пароля клієнту.',
  'Provide the phone number of the Telegram Gateway account owner.': 'Вкажіть номер телефону власника облікового запису Telegram Gateway.',
  'Provide a link to the document posted on the project\'s official website.': 'Вкажіть посилання на документ, розміщений на офіційному сайті проєкту',
  'API token can be obtained in the Telegram Gateway settings on the API page.': 'API token можна отримати у настройках Telegram Gateway на сторінці API',
  'You can optionally specify the sender username, designating a verified channel you own as the one from which the code will be sent to the user.':
    'Ви можете вказати ім\'я відправника, вказавши верифікований канал, яким ви володієте, як той, з якого код буде відправлено користувачеві.',
  'Specify the outgoing mail server address': 'Вкажіть адресу сервера вихідної пошти',
  'Specify the outgoing mail server port': 'Вкажіть порт сервера вихідної пошти',
  'Specify the encryption type': 'Вкажіть тип шифрування',
  'Specify the sender email': 'Вкажіть Email відправника',
  'Enter username': 'Вкажіть ім’я користувача',
  'Specify the email password': 'Вкажіть пароль пошти відправника',
  'Specify the minimum age of the client': 'Вкажіть мінімальний вік клієнта',
  'Specify the document signature text, including a link to the document in the form of the document name, using the automatic data substitution template - {{documentLinkName}}': 'Укажіть текст підписання документа, що містить посилання на документ у вигляді назви документа, використовуючи шаблон автоматичної підстановки даних — {{documentLinkName}}',
  'A short smart link of the service that redirects the user to the desired app store depending on the device. The link is automatically added to the QR code of the unit before the registration number. Thus, when scanning the QR code of the unit with the camera in the mobile app, the unit is booked, and when scanning with the camera of a mobile phone, the transition to the app page for downloading is performed.'
    : 'Коротке інтелектуальне посилання сервісу, який перенаправляє користувача до потрібного магазину програм залежно від пристрою. Посилання автоматично додається до QR-коду об\'єкта перед реєстраційним номером. Таким чином, при скануванні QR коду об\'єкта камерою в мобільному додатку здійснюється бронювання об\'єкта, а при скануванні камерою мобільного телефону здійснюється перехід до магазину додатків на сторінку додатка для скачування.',
  'Used to navigate to the mobile app when confirming the client\'s Email on an iOS device. Provided by the developer':
    'Використовується для переходу в мобільний додаток при підтвердженні Email клієнта на пристрої iOS. Надається розробником',
  'Used to navigate to the mobile app when confirming the client\'s Email on an Android device. Provided by the developer':
    'Використовується для переходу в мобільний додаток при підтвердженні Email клієнта на пристрої Android. Надається розробником',
  'To credit cashback to the balance of clients in all completed and successfully paid orders of the project, it is necessary to specify the value in percentage.'
    : 'Для зарахування кешбеку на баланс клієнтів у всіх завершених та успішно оплачених замовленнях проекту необхідно вказати значення у відсотках.',
  'Manage visibility of units in the client mobile app. Should be enabled by default. If you need to hide temporarily all units of the project from clients without changing status of the units, you should uncheck the box.'
    : 'Управління видимістю об\'єктів у клієнтському мобільному додатку. За промовчанням має бути увімкнено. У разі потреби тимчасового приховування всіх об\'єктів проекту від клієнтів без зміни статусу об\'єктів необхідно зняти чек-бокс.',

  'Tourist route price plan': 'План туристичного маршруту',
  'Duration days': 'Тривалість днів',
  'Time of purchase request': 'Час запиту на покупку',
  'Payment status': 'Статус платежу',
  'Time of purchase completion': 'Час здійсненої покупки',
  'Is activated': 'Чи активна покупка',
  'Tourist route purchase identifier': 'Ідентифікатор покупки туристичного маршруту',
  'Vat rate': 'Ставка ПДВ',
  'Taxation system': 'Система оподаткування',
  'Clients with debt': 'Клієнти із заборгованістю',
  Gallery: 'Галерея',
  'Show all': 'Показати все',
  Next: 'Наступний',
  Prev: 'Попередній',
  'Last day': 'Останній день',
  'Chat to WhatsApp': 'Написати у WhatsApp',
  'Order id': 'id Замовлення: ',
  'Client login': 'Логін клієнта: ',
  'Client activity levels': 'Рівні активності клієнта',
  Current: 'Поточний',
  'Currency code': 'Валюта: ',
  'Customize notifications by unit': 'Налаштування сповіщень за об\'єктами',
  'Customize notifications by client': 'Налаштування сповіщень за клієнтам',
  'Customization settings': 'Налаштування кастомізації',
  'Order price': 'Загальна ціна замовлення: ',
  'Order start time': 'Час початку замовлення',
  'Order finish time': 'Час закінчення замовлення',
  'Order completion': 'Завершення замовлення',
  'Ordering statistics': 'Статистика по замовленням',
  'Price plan name': 'Назва тарифу: ',
  'Last order': 'Останнє замовлення',
  Hour: 'Година',
  'next day': 'наст. день',
  'prev. day': 'попер. день',
  'next week': 'наст. тиждень',
  'prev. week': 'попер. тиждень',
  'next month': 'наст. місяць',
  'prev. month': 'попер. місяць',
  week: 'тиждень',
  month: 'місяць',
  'Reset filters': 'Скинути фільтри',
  'Pay penalty': 'Сплатити штраф',
  'Cancel penalty': 'Скасувати штраф',
  'Penalty successfully paid': 'Штраф успішно сплачено',
  'Penalty canceled successfully': 'Штраф успішно скасовано',
  'Confirm cancellation': 'Підтвердити скасування',
  'Consider the amount': 'Враховувати суму',
  'Consider the duration': 'Враховувати тривалість',
  'Consent text': 'Текст згоди',
  Confirm: 'Підтвердити',
  'Reason for canceling fine': 'Причина скасування штрафу',
  'Reason for canceling': 'Причина скасування',
  'Reason for write-off of property': 'Підстава для списання майна',
  'Reason for subscription termination': 'Причина припинення підписки',
  'Debt for fine': 'Заборгованість по штрафу',
  'Debt for trip': 'Заборгованість по поїздці',
  'Your reason for closing all notifications': 'Причина закриття повідомлень',
  'Client location at end of lease': 'Розташування клієнта після закінчення оренди',
  'Unit location at end of lease': 'Розташування об\'єкту після закінчення оренди',
  'Trip info': 'Інформація про поїздку',
  'Limit error, use filters': 'Занадто великий результат, використовуйте фільтри',
  'List of clients': 'Список клієнтів',
  'List of couriers': 'Список кур\'єрів',
  Limit: 'Обмеження',
  'Trip start': 'Початок поїздки',
  'Trip continue': 'Продовження поїздки',
  'Trip finish': 'Завершення поїздки',
  'Distance from Unit to Client, m': 'Відстань від об\'єкта до клієнта, м',
  m: 'м',
  'hh:mm': 'гг:хх',
  'hh:mm:ss - hh:mm:ss': 'гг:хх:сс - гг:хх:сс',
  'Order start place': 'Місце початку замовлення',
  'Order finish place': 'Місце завершення замовлення',
  'Orders price': 'Сума за замовленнями',
  'Bank card type': 'Тип банківської картки',
  'Bank cards': 'Банківські карти',
  'Bank card last four digits': 'Останні чотири цифри банківської картки',
  Banking: 'Банківські',
  'Bank card': 'Банківська картка',
  'Notification link': 'Посилання на повідомлення',
  'Send notifications': 'Розсилка сповіщень',
  'Preview image': 'Ттитульна картинка',
  'Has furniture': 'Є меблі',
  'Has fridge': 'Є холодильник',
  'With kids': 'Можна з дітьми',
  Floor: 'Поверх',
  'Window view': 'Вид з вікна',
  'Rooms amount': 'Кількість кімнат',
  'Quality repair': 'Ремонт',
  'Question type': 'Тип питання',
  Question: 'Питання',
  'Select question type': 'Виберіть тип питання',
  'Value should be like 12+13+14': 'Значення має бути 12+13+14',
  'The value must be at least 6 characters.': 'Значення має бути не менше ніж 6 символів.',
  'Invalid value': 'Неправильне значення',
  'Invalid format. Allowed: ': 'Неприпустимий формат. Дозволено: {{params}}',
  Balcony: 'Балкон',
  Bathroom: 'Санвузол',
  'Square meter rooms': 'Площа кімнат',
  'Square meter kitchen': 'Площа кухні',
  'Square meter living': 'Житлова площа',
  'Square meter full': 'Загальна площа',
  'Closest metro': 'Найближче метро',
  'Minutes to metro': 'Хвилин до метро',
  'Floors total in building': 'Всього поверхів у будинку',
  'Maximum amount of people': 'Максимальна кількість людей',
  'Next maintenance mileage': 'Наступне ТО',
  'With conditioner': 'Є кондиціонер',
  'With dishwasher': 'Є посудомийна машина',
  'With washer': 'Є пральна машина',
  'With tv': 'Є телевізор',
  'With pets': 'Можна з домашніми тваринами',
  'Near reservoir': 'Поруч водойма',
  'Near park': 'Поруч парк',
  'Year of construction': 'Рік будівництва',
  'Year of card expiry': 'Рік закінчення терміну дії карти',
  'Yandex Maps Settings': 'Налаштування Yandex Maps',
  'Ceiling height': 'Висота стель',
  'Certificate of absence (presence) of a criminal record': 'Довідка про відсутність (наявність) судимості',
  Parking: 'Паркування',
  'House type': 'Тип будинку',
  'Accommodation type': 'Тип житла',
  'Price for day': 'Ціна за добу',
  Bookings: 'Бронювання',
  'Booking info': 'Інформація про бронювання',
  'Invalid year of construction': 'Невалідний рік побудови',
  'Name can only contain letters, numbers, dashes and underscores':
    'Назва може містити лише букви, цифри, дефіси, знаки підкреслення',
  'Login can only contain letters, numbers, dashes and underscores':
    'Логін може містити лише літери, цифри, дефіси, знаки підкреслення',
  'Login can\'t contain a whitespace': 'Логін не може містити пробіл',
  'Name can\'t start with dash or underscore characters': 'Назва не може починатися з дефісу або підкреслення',
  'Internal name will be used for administrative purposes only and will not be available to the client.':
    'Вкажіть внутрішню назву використовується лише в адміністративних цілях і не буде доступною для клієнта.',
  'Unit type name may only contain lowercase latin letters, hyphens and underscores':
    'Назва типу об\'єкта може містити лише латинські літери в нижньому регістрі, дефіси та символи підкреслення',
  'Unit types': 'Типи об\'єктів',
  'Apartment number': 'Номер квартири',
  apartment: 'квартира {{val}}',
  'Email host': 'Хост електронної пошти',
  'Email username': 'Ім\'я користувача пошти',
  'Email password': 'Пароль пошти',
  'Email port': 'Порт пошти',
  'Email encryption': 'Тип шифрування',
  'Email from': 'Електронна пошта для надсилання',
  Date: 'Дата',
  'Date from': 'Дата початку',
  'Date to': 'Дата закінчення',
  'Confirm version': 'Підтвердити зміну',
  'Reject version': 'Відхилити зміну',
  Reject: 'Відхилити',
  'Delivery time': 'Час доставки',
  'Delivery address': 'Адреса доставки',
  'Return address': 'Адреса повернення',
  'Delivery point': 'Точка доставки',
  'Return point': 'Точка повернення',
  Returned: 'Повернені',
  'Active booking': 'Активне бронювання',
  'Activation log': 'Журнал активації',
  'Another region': 'Інший регіон',
  'Value time is not correct': 'Час введено неправильно',
  'Update type': 'Тип зміни',
  Updated: 'Оновлено',
  Update: 'Змінити',
  'Car delivered': 'Машину доставлено',
  'Car price': 'Ціна автомобіля',
  'Card expiry month': 'Місяць закінчення терміну дії картки',
  'Close booking': 'Закрити бронювання',
  'Request for update': 'Запит на оновлення',
  'Request to fill out the registration form': 'Запросити заповнення форми реєстрації',
  'Fill out the registration form yourself': 'Заповнити форму реєстрації самостійно',
  Recalculate: 'Перерахувати',
  'Order created': 'Замовлення створено',
  'Order cost': 'Вартість замовлення',
  'Update confirmed': 'Оновлення підтверджено',
  'Update rejected': 'Оновлення відхилено',
  'Upload a file in .txt format with a list of customers\' phone numbers in a column, without spaces or other punctuation marks.':
    'Завантажте файл у форматі txt зі списком номерів клієнтів, прописаних у стовпчик, без пробілів та інших розділових знаків.',
  'Booking closed': 'Бронювання закрите',
  'Upload the document in HTML format, having previously specified the necessary data substitution templates in its content.': 'Завантажте документ у форматі HTML, попередньо зазначивши в його змісті необхідні шаблони підстановки даних.',
  'Upload a photo of the document': 'Завантажте фотографію документа',
  'Upload the document (HTML)': 'Завантажте документ (HTML)',
  'Booking confirmation': 'Підтвердження бронювання',
  'Bonus package purchases': 'Покупки бонусних пакетів',
  'Bonus on order completion': 'Бонус після завершення замовлення',
  'End user type': 'Тип клієнта',
  'Cot amount': 'Кількість дитячих ліжечок',
  'Entrance number': 'Номер під\'їзду',
  entrance_number: 'під\'їзд {{val}}',
  'Enter ID': 'Введіть ID',
  'Enter API-key': 'Введіть API-key',
  'Enter email': 'Введіть email',
  'Enter code': 'Введіть код',
  'Enter contact': 'Введіть контакт',
  'Enter consent text': 'Введіть текст згоди',
  'Enter the amount': 'Введіть кількість',
  'Enter value': 'Введіть вартість',
  'Enter last name': 'Введіть прізвище',
  'Enter the name': 'Введіть ім\'я',
  'Enter middle name': 'Введіть по-батькові',
  'Enter phone number': 'Введіть номер телефона',
  'Enter the interest value': 'Введіть значення відсотка',
  'Enter the amount value': 'Введіть значення суми',
  'Enter the amount in hours': 'Введіть значення суми у годиннику',
  'Enter the document text': 'Введіть текст документа',
  'Enter the signing text': 'Введіть текст підписання',
  'Enter the cashback percentage': 'Вкажіть відсоток кешбеку.',
  'Enter the amount in the country\'s currency': 'Вкажіть суму у валюті країни.',
  'Enter number of days': 'Введіть кількість днів',
  'Enter number': 'Введіть номер',
  'Enter number prefix': 'Введіть префікс номера',
  'Enter subscription name': 'Введіть назву абонементу',
  'Enter a name': 'Введіть назву',
  'Enter a name for the new schedule.': 'Введіть назву нового розкладу.',
  'Enter a name for the icon.': 'Вкажіть назву іконки.',
  'Enter a unique identifier': 'Введіть унікальний ідентифікатор',
  'Enter an address': 'Введіть адресу',
  'Enter short description text': 'Введіть текст короткого опису',
  'Enter short description text 1': 'Введіть текст короткого опису 1',
  'Enter short description text 2': 'Введіть текст короткого опису 2',
  'Enter text for detailed description': 'Введіть текст детального опису',
  'Enter text to search': 'Введіть текст для пошуку',
  'Enter name of the rate': 'Введіть назву тарифу',
  'Enter name': 'Введіть назву',
  'Enter service name 1': 'Введіть назву послуги 1',
  'Enter service name 2': 'Введіть назву послуги 2',
  'Enter service name 3': 'Введіть назву послуги 3',
  'Enter service name 4': 'Введіть назву послуги 4',
  'Enter price': 'Введіть ціну',
  'Enter price for service 1': 'Введіть ціну на послугу 1',
  'Enter price for service 2': 'Введіть ціну на послугу 2',
  'Enter price for service 3': 'Введіть ціну на послугу 3',
  'Enter price for service 4': 'Введіть ціну на послугу 4',
  'Enter cost': 'Введіть вартість',
  'Enter description text': 'Введіть текст опису',
  'Enter description': 'Введіть опис',
  'Enter driver\'s license number': 'Введіть номер посвідчення водія',
  'Enter serial number': 'Введіть порядковий номер',
  'Enter series and document number': 'Введіть серію та номер документа',
  'Enter charge value': 'Введіть значення заряду',
  'Enter the serial number of the object': 'Вкажіть серійний номер об\'єкту',
  'Enter registration number': 'Введіть реєстраційний номер',
  'Enter IMEI': 'Введіть IMEI',
  'Enter reg. object number': 'Введіть реєстр. номер об\'єкта',
  'Enter net cost': 'Введите собівартість',
  'Enter a free-form description of the color, for example, "Beige", "Metallic Green", etc.':
    'Введіть у довільній формі опис кольору, наприклад, «Бежевий», «Зелений металік» та ін.',
  'Enter the number of the SIM card installed in the telematics equipment':
    'Вкажіть номер SIM-картки, встановлений у телематичному обладнанні',
  'Enter comment text': 'Введіть текст коментаря',
  'Enter text': 'Введіть текст',
  'Enter a comment': 'Введіть коментар',
  'Enter amount': 'Введіть суму',
  'Enter percentage': 'Введіть відсоток',
  'Enter command text': 'Введіть текст команди',
  'Enter notification text': 'Введіть текст повідомлення',
  'Enter the number of days to pay the invoice. Invoice date for the billing period is the start date of a new billing period. Account will be blocked in case of non-payment of the debt within the specified period.':
    'Вкажіть кількість днів на оплату з моменту виставлення рахунку. Моментом виставлення рахунка вважається початок нового розрахункового періоду. У разі не надходження коштів за виставленим рахунком протягом встановленого періоду, обліковий запис буде заблоковано.',
  'Enter text of the client\'s agreement to the terms of the document. For example: "I have read the terms of the privacy policy and, by checking this box, I agree to its terms."': 'Введіть супровідний текст згоди клієнта з умовами документа. Наприклад: «Я ознайомився з умовами політики конфіденційності і, встановлюючи позначку в цьому полі, погоджуюся з її умовами».',
  'Enter mileage': 'Введіть пробіг',
  'Enter account login': 'Введіть логін облікового запису',
  'Enter login': 'Введіть логін',
  'Enter your name': 'Введіть ім\'я',
  'Enter your phone number': 'Введіть номер телефону',
  'Enter password': 'Введіть пароль',
  'Enter a password': 'Ввести пароль',
  'Enter passport number': 'Введіть номер паспорта',
  'Enter position': 'Введіть посаду',
  'Enter port': 'Введіть порт',
  'Enter API token': 'Введіть API token',
  'Enter the Full Name of the contact person who has access to the user account':
    'Вкажіть Прізвище Ім\'я По батькові контактної особи, яка має доступ до облікового запису користувача',
  'Enter the phone number of the contact person who has access to the user account in the format +375291111111':
    'Вкажіть номер телефону контактної особи, який має доступ до облікового запису користувача',
  'Enter the number n the format +375291111111': 'Введіть номер у форматі +375291111111',
  'Enter the user name in the format @ivanovivanivanovich': 'Введіть ім\'я користувача у форматі @ivanovivanivanovich',
  'Enter the link in the format https://t.me/BF_news1': 'Введіть посилання у форматі https://t.me/BF_news1',
  'Enter the name of the parameter by which the battery charge level value will be calculated': 'Введіть назву параметра, за яким здійснюватиметься обчислення рівня заряду АКБ',
  'Enter the address of your actual residence': 'Введіть адресу фактичного проживання',
  'Enter Push notification text': 'Push Bildiriş Mətni daxil edin',
  'Enter verification code': 'Введіть код перевірки',
  'Enter promo code': 'Введіть промокод',
  'Enter age': 'Введіть вік',
  'Enter the cashback percentage value': 'Введіть значення відсотка кешбеку',
  'Enter the key': 'Введіть ключ',
  'Enter the minimum duration': 'Введіть мінімальну тривалість',
  'Enter sort priority': 'Введіть пріоритет сортування',
  'Enter parameter name': 'Введіть назву параметра',
  'Enter parameter value': 'Введіть значення параметра',
  'Enter the translation of the client activity level name':
    'Вкажіть назву рівня активності клієнта обраною мовою перекладу.',
  'Enter the internal name of the branch in any format. The internal name is used for administrative purposes only and is not used in the mobile app for clients.':
    'Вкажіть внутрішню назву філії у довільній формі. Внутрішня назва використовується лише в адміністративних цілях і не відображається у мобільному додатку для клієнтів.',
  'Enter the internal name of the Legal Entity in any format. The internal name is used for administrative purposes only and is not used in the mobile app for clients.':
    'Вкажіть внутрішню назву юридичної особи у довільній формі. Внутрішня назва використовується лише в адміністративних цілях і не відображається у мобільному додатку для клієнтів.',
  'Enter a short description': 'Введите краткое описание',
  'Enter a detailed description': 'Введіть детальний опис',
  'Enter the title of the question': 'Введіть заголовок питання',
  'Enter a heading': 'Введіть заголовок',
  'Enter the address of registration': 'Введіть адресу реєстрації',
  'Enter the name of the client\'s activity level. This name will be used for administrative purposes only and will not be available to the client. The client\'s activity level name is set when adding transfers':
  'Вкажіть назву рівня активності клієнта. Ця назва буде використовуватися тільки в адміністративних цілях і не буде доступною для клієнта. Назва рівня активності для клієнта встановлюється при додаванні переказів',
  'Enter the value of the parameter, upon reaching which the charge level will be 0%': 'Введіть значення параметра, за досягнення якого рівень заряду становитиме 0%.',
  'Enter the value of the parameter, upon reaching which the charge level will be 100%': 'Введіть значення параметра, за досягнення якого рівень заряду становитиме 100%.',
  'Enter the document name that will be available to the client in the mobile app.': 'Введіть назву документа, яка буде доступна клієнту в мобільному застосунку.',
  'Enter a name for the geopoint. We recommend adding, for example, an address to the name, so you can quickly find the geopoint in the list if needed.': 'Вкажіть назву геоточки. Рекомендуємо додавати до назви, наприклад, адресу, щоб за потреби можна було швидко знайти геоточку у списку.',
  'Passport number': 'Номер паспорта',
  'Enrollment form': 'Форма зарахування',
  'Passport term': 'Строк дії паспорту',
  'Passport photo': 'Фотографія паспорта',
  'Passport photo (New)': 'Фотографія паспорта (Нове)',
  'Passport selfies': 'Селфі з паспортом',
  'Passport selfies (New)': 'Селфі з паспортом (Нове)',
  'Series and number': 'Серія і номер',
  'Driver license number': 'Номер прав',
  'Driver\'s license number': 'Номер посвідчення водія',
  'Driver\'s license category': 'Категорія посвідчення водія',
  'Driver license term': 'Строк дії прав',
  Passport: 'Паспорт',
  'One-time password': 'Одноразовий пароль',
  'Multiple use password': 'Багаторазовий пароль',
  'Selfie with passport': 'Селфі з паспортом',
  'Validity period of driver\'s license': 'Термін дії посвідчення водія',
  'Driver\'s licence. Front side': 'Водії лисі. Лицьова сторона',
  'Driver\'s licence. Front side (New)': 'Водії лисі. Лицьова сторона (Нове)',
  'Driver\'s licence. Reverse side': 'Водійське посвідчення. Зворотний бік',
  'Driver\'s licence. Reverse side (New)': 'Водійське посвідчення. Зворотний бік (Нове)',
  'Driver\'s license categories': 'Категорії посвідчення водія',
  'Driver\'s license': 'Водійські права',
  'Driver license front': 'Посвідчення водія, передня сторона',
  'Driver license back': 'Посвідчення водія, задня сторона',
  Selfie: 'Селфі',
  'E-mail': 'E-mail',
  'Term of use': 'Угода користувача',
  'Privacy policy': 'Згода на обробку даних',
  'End user verified': 'Клієнт підтверджений',
  'End user rejected': 'Дані користувача відхилені',
  'Can\'t verify end user, everything has to be confirmed': 'Неможливо підтвердити клієнта, всі кроки реєстрації мають бути підтверджені',
  'Registration data': 'Реєстрація клієнта',
  'Registration history': 'Історія проходження реєстрації',
  'Registration number must correspond to the specified number in the name of the object (numerical value). Based on the specified registration number, the system generates a QR code required for ordering an object by a client. If for some reason the QR code is not readable, the customer enters the registration number manually to start the rental.':
  'Реєстраційний номер повинен відповідати вказаному номеру у назві об\'єкта (цифрове значення). На підставі зазначеного номера реєстрації системою генерується QR-код, необхідний для замовлення об\'єкта клієнтом. Якщо QR-код з якоїсь причини не зчитується, для початку оренди клієнт вводить реєстраційний номер вручну.',
  'Nothing to reject': 'Нічого не обрано',
  'Nothing found': 'Нічого не знайдено',
  'Return to customer': 'Відхилити клієнта',
  'Verify account': 'Підтвердити акаунт',
  'Verified sender name': 'Верифіковане ім\'я відправника',
  'Maximum people allowed': 'Максимальна кількість людей дозволена',
  'Confirm apartment': 'Підтвердити квартиру',
  'Arrive time': 'Час прибуття',
  'Departure time': 'Час виїзду',
  'Depending on the selected type of subscription, different conditions for its provision are available. Starts - type of subscription to provide access to tariffs with zero cost of starts for a set period of validity of the subscription. Minutes - type of subscription to provide free rental minutes for a set period of validity of the subscription. Trips - a type of subscription for providing free trips for a set period of validity.':
    'Залежно від вибраного типу абонементу, доступні різні умови його надання. Старти - тип абонементу для надання доступу до тарифів із нульовою вартістю стартів на встановлений період дії абонементу. Хвилини - тип абонементу надання безкоштовних хвилин оренди на встановлений період дії абонементу. Поїздки – тип абонементів для надання безкоштовних поїздок на встановлений період дії.',
  'Depending on the selected role, the user selection will be displayed':
    'Залежно від вибраної ролі відображається вибір користувача',
  'Depending on the role of the user in the system there are different functionalities. You can find detailed information about the differencies in user roles you can find in our documentation':
    'Залежно від ролі користувача, доступні різні функціональні можливості в системі. З детальною інформацією про функціональні особливості кожної з доступних ролей можна ознайомитись у нашій документації',
  'Depending on the selected role of the account owner, a list of users of the corresponding role will be available.':
    'Залежно від обраної ролі власника облікового запису буде доступний список користувачів відповідної ролі.',
  'Depending on the assignment type, different document types are available. The "General" document type is a link to a legal document posted on the project website. The "Rental Agreement" is also a general document type; however, depending on the business model, this document can be used in different places, so it has been designated as a separate type. The "Acceptance Certificate" and "Power of Attorney" document types are generated based on an added document template, automatically populating the client and rented unit details.': 'Залежно від типу призначення доступні різні типи документів. «Загальний» тип документа є посиланням на правовий документ, розміщений на сайті проєкту. «Договір оренди» також є загальним типом документа, однак залежно від бізнес-моделі цей документ може використовуватися в різних місцях, тому його виділено як окремий тип. Типи документів «Акт приймання-передачі» та «Довіреність» формуються на основі доданого шаблону документа з автоматичним підставленням даних клієнта та орендованого об’єкта.',
  'Service hours': 'Час на прибирання',
  'Date publish': 'Дата публікації',
  'Usages log': 'Журнал використань',
  'Activated at': 'Дата активації',
  'Minimum transaction amount': 'Мінімальна сума транзакції',
  'Card binding transaction amount': 'Сума транзакції прив\'язки картки',
  'Change of terms': 'Зміна умов',
  'Change quantity': 'Змінити кількість',
  'Minimum transaction amount currency': 'Валюта мінімальної суми транзакції',
  Customer: 'Клієнт',
  Custom: 'Користувальницький',
  'Don\'t show it again': 'Більше не показувати',
  'Reject publish': 'Відхилити публікацію квартири',
  'Flat status': 'Статус квартири',
  'Minimum rental period': 'Мінімальний термін оренди',
  'Minimum number of satellites': 'Мінімальна кількість супутників',
  'Minimum altitude above sea level, m': 'Мінімальна висота над рівнем моря, м',
  'Maximum altitude above sea level, m': 'Максимальна висота над рівнем моря, м',
  'altitude-region-hint': 'Для застосування фільтрації невалідних координат за висотою необхідно встановити допустимий діапазон висоти над рівнем моря в межах регіону. Скористайтеся топографічною картою місцевості, щоб отримати відповідну інформацію. Фільтрація застосовується лише до онлайн‑повідомлень для запобігання викидам та фіксації об’єкта на карті за останніми валідними координатами. В історії повідомлень зберігаються фактичні координати, надіслані обладнанням. Звертаємо вашу увагу, що для застосування фільтрації необхідно заповнити як мінімальне, так і максимальне значення висоти, а об’єкт має бути вручну прив’язаний до регіону',
  Descriptions: 'Описи',
  Discounts: 'Знижки',
  'Increased tariff': 'Підвищений тариф',
  'Insurance balance': 'Баланс із страхування',
  'Insurance report': 'Звіт зі страхування',
  'Insurance cancellation': 'Відмена страховки',
  'end-user-order-insurance-text': 'При скасуванні страховки здійснюється автоматичне повернення коштів. Якщо страховку було сплачено за банківською карткою, кошти будуть повернуті на картку клієнта. Якщо страховку було сплачено за балансом, операцію списання коштів з балансу буде скасовано. Партнерська винагорода, згідно з встановленими умовами, буде також скасована.',
  'Report format': 'Формат звіту',
  'Insurer type': 'Тип страховика',
  'Illustration for mobile application': 'Ілюстрація для мобільного додатка',
  'Transfer to the balance': 'Нараховувати на баланс',
  'Percent value': 'Відсоток нарахування',
  'Base URL': 'Базовий URL',
  'Insurance policy template (HTML)': 'Шаблон страхового полісу (HTML)',
  'Email for sending insurance reports': 'Email для надсилання звітів зі страхування',
  'Custom subject for insurance report messages': 'Кастомна тема повідомлення для надсилання звітів щодо страхування',
  Subject: 'Тема',
  'Sending interval': 'Періодичність відправлення',
  Insurer: 'Страховик',
  'Select insurer': 'Виберіть страховика',
  'If partner has its own contract with an insurance company, then you should select the previously created partner\'s insurer from the list. Otherwise, this field must be left blank.':
    'Якщо партнер має свій договір зі страховою компанією, то необхідно обрати раніше створеного страховика партнера зі списку. ' +
    'В іншому випадку, дане поле необхідно залишити незаповненим.',
  'If the income from insurance is distributed between the partner and the owner of the project / platform, then, depending on who accepts the payment for insurance, % of the insurance cost is either credited to the partner\'s balance or written-off. To specify the percentage value, select either "Add to balance" or "Withdraw from balance". If the insurance income is not distributed, select "NO".' :
    'Якщо дохід від страхування розподіляється між партнером та власником проекту/платформи, то, залежно від того, хто приймає платіж за страхування, % від вартості страхування або зараховується на баланс партнера, або списується. Для вказання значення відсотка необхідно вибрати або "Зарахувати до балансу", або "Списати з балансу". Якщо ж дохід від страхування не розподіляється, виберіть НІ.',
  'If the news is intended to be displayed in all regions of the country, select the Country type. If the news can be displayed only in certain regions of the country, select the Regions type to be able to specify the required regions.' :
    'Якщо новина призначена для відображення у всіх регіонах країни, виберіть тип Країна. Якщо новину можна відобразити лише в окремих регіонах країни, щоб вказати необхідні регіони, виберіть тип Регіони.',
  'If the news is intended to promote tourist routes or subscriptions, you can add buttons to go from the news article directly to the catalog of routes or subscriptions.' :
    'Якщо новина призначення для просування туристичних маршрутів або підписок, можна додати кнопки переходу з новини безпосередньо в каталог маршрутів або підписок відповідно.',
  'It is necessary to specify the component type to create a component model. If the appropriate type is not listed you can create a new one on the Component Type Page.':
    'Для створення моделі комплектуючого необхідно вказати тип комплектуючого, якому відповідає модель, що створюється. Якщо у списку немає відповідного типу, створіть новий на сторінці Типи комплектуючих.',
  'If a serial number is required for each component in this model, check this box. Components with serial numbers are added on the "Components" page. If components in this model do not have serial numbers, but only quantitative values, leave this field blank. Components without serial numbers are added on the "Components without s/n" page. Please note that this parameter cannot be changed once at least one component for this model has been added.':
    'Якщо для кожного комплектуючого моделі потрібне зазначення серійного номера, необхідно поставити позначку в цьому полі. Додавання комплектуючих із серійними номерами здійснюється на сторінці «Комплектуючі». Якщо комплектуючі моделі не мають серійних номерів, а мають лише кількісні показники, залиште це поле порожнім. Додавання комплектуючих без серійних номерів здійснюється на сторінці «Комплектуючі без с/н». Звертаємо вашу увагу, що змінити цей параметр буде неможливо після додавання хоча б одного комплектуючого до даної моделі.',
  'If the component model only matches a specific model(s) of an unit, check this box and specify the unit type and model(s) in the "Assignments" section that appears. If the component model is not limited to specific unit models, leave this field blank. (Accessories, for example)':
    'Якщо модель комплектуючого відповідає лише певній моделі(-ям) об\'єкта, необхідно поставити галочку в даному полі і, в блоці «Призначення», вказати тип і модель(-и) об\'єктів. Якщо модель комплектуючого не обмежена певними моделями, наприклад, аксесуарами, залиште це поле порожнім.',
  'If the use of the service requires the client\'s consent to the terms of the document, check this point. If you simply want to add the document to the list of available legal documents in the mobile app, uncheck this box.': 'Якщо для використання сервісу потрібна згода клієнта з умовами документа, поставте позначку в цьому полі. Якщо ви просто хочете додати документ до переліку доступних правових документів у мобільному застосунку, зніміть позначку в цьому полі.',
  'If a geofence has day of week or time restrictions, you can set the geofence\'s operating schedule by specifying the geofence\'s working days and/or working hours. Outside of business hours, the geofence\'s logic will not function, and the geofence will not be visible to clients in the mobile app.': 'Якщо на території геозони є обмеження за днями тижня або за часом, ви можете встановити розклад роботи геозони, вказавши робочі дні та/або робочий час. Поза робочим часом логіка геозони не працюватиме, і геозона не відображатиметься клієнтам у мобільному застосунку.',
  'Percent of insurance amount': 'Відсоток від суми страхування',
  'Acquirer for insurance payments': 'Еквайєр для платежів зі страхування',
  'Report log': 'Журнал звітів',
  'Arbitrary report': 'Довільний звіт',
  'Report interval': 'Інтервал звіту',
  'Download report': 'Завантажити звіт',
  'It will be displayed in the mobile application in the first line of the tariff preview of the tariff list.':
    'Відображатиметься в мобільному додатку в першому рядку прев\'ю тарифу списку тарифів. ',
  'It will be displayed in the mobile application on the second line of the tariff preview of the tariff list.':
    'Відображатиметься в мобільному додатку на другому рядку прев\'ю тарифу списку тарифів.',
  'It should be noted if you want the tariff to become available in the mobile application immediately after saving.':
    'Необхідно зазначити, якщо ви хочете, щоб тариф став доступним у мобільному додатку відразу після збереження.',
  'It should be noted if this rate is the cheapest default rate': 'Необхідно зазначити, якщо цей тариф є найдешевшим тарифом за умовчанням',
  'It should be noted if you want to add a schedule for the availability of this tariff by time of day, days of the week, etc.':
    'Необхідно зазначити, якщо ви бажаєте додати розклад доступності даного тарифу за часом доби, днями тижня тощо.',
  'It is necessary to specify the language in which the information for the client is provided.':
    'Необхідно вказати мову, якою надається інформація для клієнта',
  'It\'s on': 'Включено',
  'It\'s off': 'Вимкнена',
  'Rent type': 'Тип оренди',
  Reward: 'Винагорода',
  'Unavailable dates': 'Недоступні дати',
  Unavailable: 'Недоступний',
  'Cancellation cost': 'Вартість скасування',
  'Free cancellation before (in hours)': 'Безкоштовне скасування до (у годинах)',
  'Free minutes': 'Безкоштовні хвилини',
  'Time for service (in hours)': 'Час на прибирання (у годинах)',
  'Price for service': 'Ціна за прибирання',
  'Collateral value': 'Заставна вартість',
  'Cancellation cost (percents from collateral value)': 'Вартість скасування (у відсотках від заставної вартості)',
  'Days of week': 'Дні тижня',
  'Value (in percents)': 'Значення (у відсотках)',
  'Discount from (in days)': 'Знижка від (в днях)',
  'Discount from (in hours)': 'Знижка від (у годинах)',
  'Rent periods': 'Періоди бронювань',
  'Rent / Insurance': 'Оренда / Страховка',
  'Private key': 'Закритий ключ',
  'Public Key (iOS)': 'Публічний ключ (iOS)',
  'Private Key (iOS)': 'Закритий ключ (iOS)',
  'Captcha is active': 'Captcha активна',
  'Captcha public key': 'Captcha публічний ключ',
  'Captcha secret key': 'Captcha закритий ключ',
  'Captcha IOS public key': 'Captcha IOS публічний ключ',
  'Captcha IOS secret key': 'Captcha IOS закритий ключ',
  'Cashback percent': 'Відсоток кешбеку',
  'Cash register registration number': 'Реєстраційний номер каси',
  'Legal documents': 'Правові документи',
  'Legal entities': 'Юридичні особи',
  'Legal entity': 'Юр. особа',
  'Less than 20% (hidden in the app)': 'Менше 20% (приховано у додатку)',
  'Less than 20%': 'Менше 20%',
  'Level of demand': 'Рівень попиту',
  'Leave a comment in any format. This is an optional field. This field is used for administrative purposes only and is not used in the mobile app for clients.':
    'Залишіть коментар у довільній формі. Необов\'язкове заповнення поле. Використовується лише в адміністративних цілях і не відображається у мобільному додатку для клієнтів.',
  'Client activity level': 'Рівень активності клієнта',
  Level: 'Рівень',
  Leasing: 'Передача в оренду',
  'Leased out': 'Передано в оренду',
  'Country documents': 'Документи в країні',
  'Add country document': 'Додати документ в країні',
  'Add a comment to this tariff. The comment is displayed only in the admin panel.':
    'Додайте коментар до цього тарифу. Коментар відображається лише в адміністративній панелі.',
  'Add a step': 'Додати крок',
  'Add option': 'Додати варіант',
  Option: 'Варіант',
  'Add a question': 'Додати питання',
  'Delete country document': 'Видалити документ в країні',
  Translates: 'Переклади',
  Link: 'Посилання',
  'Link to detailed information': 'Посилання на докладну інформацію',
  'Link to the document': 'Посилання на документ',
  'Link to the insurance company is terms and conditions page': 'Посилання на сторінку умов страхування страхової компанії',
  'Text when accepting document': 'Текст при прийнятті документа',
  'Edit rent period': 'Змінити період бронювання',
  'Add rent period': 'Додати період бронювання',
  'Time from': 'Час початку',
  'Time must be 3600 seconds or more': 'Час має бути не менше 3600 секунд.',
  'Time must be 1800 seconds or more': 'Час має бути не менше 1800 секунд.',
  'Time to': 'Час закінчення',
  'Change booking': 'Змінити бронювання',
  'Make reservation': 'Створити бронювання',
  'make changes to the payment terms in the current billing period upon saving changes.':
    'внести зміну умов оплати у поточному розрахунковому періоді за фактом збереження змін.',
  'Type of property': 'Вид майна',
  'Type of business model': 'Тип бізнес-моделі',
  'View outside': 'Вид з вікна',
  'Previous balance': 'Попередній баланс',
  'New balance': 'Новий баланс',
  'New (inactive)': 'Нові (неактивні)',
  'New (active)': 'Нові (активні)',
  'New messages from units': 'Нові повідомлення від об\'єктів',
  'New services': 'Нові заявки',
  'New ones first': 'Спочатку нові',
  'Old ones first': 'Спочатку старі',
  'Amount in coins': 'Сума в монетах',
  'Purchase canceled': 'Покупка скасована',
  'Purchase region': 'Регіон покупки',
  Purchase: 'Покупка',
  'Purchase finished': 'Покупка завершена',
  'Purchase status': 'Статус покупки',
  Pending: 'В обробці',
  'Unknown purchase status': 'Невідомий статус покупки',
  'Cashback Percent': 'Відсоток кешбеку',
  'Purchase time': 'Час покупки',
  'Purchase declined': 'Покупка відхилена',
  'Purpose of operation': 'Призначення операції',
  'Unit assignment': 'Призначення об\'єкту',
  'Operation declined - insufficient funds': 'Операція відхилена - недостатньо коштів',
  'Operation declined': 'Операція відхилена',
  'Payment number': 'Номер платежу',
  'Transaction ID': 'ID транзакції',
  'Short description 1': 'Короткий опис 1',
  'Short description 2': 'Короткий опис 2',
  'Account number': 'Номер рахунку',
  'Finished by': 'Ким завершений',
  Finished_: 'Завершена',
  Server: 'Сервер',
  ORDER_FINISH_BY_USER: 'Користувач {{user}}',
  'Contact type': 'Тип контакту',
  Contact: 'Контакт',
  'Contact information': 'Контактні дані',
  'Contact person': 'Контактна особа',
  'Content language': 'Мова змісту',
  'HelpCrunch organisation': 'HelpCrunch organisation',
  'New HelpCrunch APP ID': 'Новий HelpCrunch APP ID',
  'New HelpCrunch secret': 'Новий HelpCrunch secret',
  'HelpCrunch APP ID': 'HelpCrunch APP ID',
  'HelpCrunch secret': 'HelpCrunch secret',
  'QRCode size': 'Розмір реєстраційного номера',
  'QR sharing': 'QR-шерінг',
  'Flash call balance': 'Баланс авторизаційні дзвінки',
  'Debt by trips': 'Заборгованість по поїздках',
  'Debt by penalties': 'Заборгованість по штрафах',
  Declined: 'Відхилена',
  'Login for payments by binding': 'Логін для платежів по зв\'язці',
  'Password for payments by binding': 'Пароль для платежів по зв\'язці',
  'w.': 'н.',
  'Work shifts': 'Робочі зміни',
  'Working days': 'Робочі дні',
  'Fiscalization service API login': 'логін API сервісу фіскалізації',
  'Fiscalization service API password': 'пароль API сервісу фіскалізації',
  'Success probability percent': 'Відсоток ймовірності успіху',
  'Bank card first six digits (leave blank for random)': 'Перші 6 цифр банківської картки (залишіть порожнім для випадкового генерування)',
  'Bank card last four digits (leave blank for random)': 'Останні 4 цифри банківської картки (залишіть порожнім для випадкового генерування)',
  'Bank card type (leave blank for random)': 'Тип банківської картки (залишіть порожнім для випадкового генерування)',
  'Bank card expiration time (MM/YY format, leave blank for random)': 'Термін дії банківської картки (формат ММ/РР, залиште порожнім для випадкового генерування)',
  'Transit account acquirer': 'Еквайєр транзитного рахунку',
  'Transit account': 'Транзитний рахунок',
  'Default commission percent': 'Відсоток комісії за умовчанням',
  'Default map': 'Карта за замовчуванням',
  'Refund transaction': 'Повернути кошти',
  'Are sure you want to refund this transaction': 'Ви дійсно бажаєте повернути кошти',
  'Are you sure you want to cancel your subscription purchase and get a refund?':
    'Ви дійсно бажаєте скасувати покупку абонементу та повернути кошти?',
  'Are you sure you want to export table data?': 'Ви впевнені, що хочете виконати експорт даних таблиці?',
  'Are you sure you want to end the courier\'s work shift?': 'Ви впевнені, що хочете завершити робочу зміну кур\'єра?',
  'Are you sure you want to remove the courier from the group?': 'Ви впевнені, що хочете видалити кур\'єра із групи?',
  'Transaction was successfully refunded': 'Повернення коштів успішно здійснено',
  'Error of transaction refund': 'Не вдалося виконати повернення коштів',
  'Unknown bank card type': 'Невідомий тип банківської картки',
  Acquiring: 'Еквайринг',
  'Acquiring for balance replenishment': 'Еквайринг поповнення балансу',
  'Acquiring payment acceptance': 'Еквайринг прийому платежів',
  'This field is used only when migrating from one acquirer to another.': 'Це поле використовується тільки при міграції з одного еквайєра на інший.',
  'This field is for reference purposes only. It is recommended to include specific characteristics and features of the hardware model as a description.': 'Це поле містить довідкову інформацію. Рекомендується в описі зазначати специфічні характеристики моделі обладнання та її особливості.',
  'Next acquirer for insurance payments': 'Наступний еквайєр для платежів зі страхування',
  'Next acquirer': 'Наступний еквайєр',
  'Insurance payment type': 'Тип платежу за страховку',
  'Subscription fee merchant': 'Мерчант абон. плати',
  'Replenish balance': 'Поповнити баланс',
  'Top-up balance': 'Поповнити баланс',
  'Top-up amount': 'Сума поповнення',
  'Amount to be withdrawn from card': 'Буде списано з карти',
  Proceed: 'Продовжити',
  'Payment settings': 'Налаштування платежу',
  'Amount in your currency': 'Сума у валюті вашого користувача',
  'Amount in currency of payment system': 'Сума у валюті платіжної системи',
  'Replenish your balance with': 'Поповнюйте свій баланс за допомогою',
  Continue: 'Продовжити',
  'Payment amount must be greater': 'Сума платежу має бути більшою',
  'Maximum allowable amount has been exceeded': 'Перевищено максимально допустиму суму',
  'Replenish balance balance failed': 'Не вдалося поповнити баланс',
  'Replenish balance was canceled': 'Поповнення балансу скасовано',
  'Replenish balance was declined': 'Поповнення балансу відхилено',
  'Replenish balance successfully completed': 'Баланс успішно поповнено',
  'Account balance successfully replenished': 'Баланс успішно поповнено',
  REPLENISH_USER_BALANCE_ERROR_MESSAGE:
    'Послуга поповнення балансу за допомогою платіжної системи {{paymentSystem}} не доступна. Будь ласка, зверніться до служби тих. підтримки.',
  Icon: 'Іконка',
  'Icon Library': 'Бібліотека іконок',
  'Image height is too large': 'Занадто велика висота картинки',
  'Image width is too large': 'Занадто велика ширина картинки',
  'Image size is too large': 'Занадто великий розмір картинки (Макс. розмір 15 кілобайт)',
  'Telegram Chat ID': 'Ідентифікатор чату Telegram',
  'Telegram bot api key': 'API-ключ телеграм-бота',
  'Telegram account': 'Акаунт Telegram',
  'Telegram Group': 'Група телеграм',
  'Send message to telegram': 'Надіслати повідомлення в telegram',
  'Max. count of bookings (0 - no limits)': 'Максимальна кількість бронювань (0 - без обмежень)',
  'Image format must be SVG or PNG': 'Формат зображення має бути SVG або PNG',
  'Image format must be SVG': 'Формат зображення має бути SVG',
  Detailing: 'Деталізація',
  'Averages-statistic': 'Середня тривалість стану активних об\'єктів в зазначений період',
  'Object-statistic-description': 'Об\'єкти, які переводили в статус Доступний у зазначений період',
  'Object models': 'Моделі об\'єктів',
  'Balance-statistic': 'Балансові',
  'Refunds(balance)': 'Повернення (балансові)',
  Refunded: 'Повернено',
  'Refund amount': 'Сума повернення',
  'Related operations': 'Пов\'язані операції',
  'Cancellation of debt': 'Скасування заборгованості',
  'coming soon': 'скоро',
  'Assigned to regions': 'Призначений на регіони',
  'All regions': 'Всі регіони',
  'All users': 'Всі користувачі',
  'All user objects': 'Усі об\'єкти користувача',
  'All couriers': 'Усі кур\'єри',
  'My couriers': 'Мої кур\'єри',
  'Advanced holding settings': 'Розширені налаштування холдування',
  'Holding confirmation': 'Підтвердження холдування',
  'Mandatory card binding': 'Обов\'язкова прив\'язка картки',
  'Card binding': 'Прив\'язка картки',
  'For new clients': 'Для нових клієнтів',
  'Tariffs with this option will be available to clients without finished orders in place of regular tariffs': 'Такі тарифи пропонуватимуться новим клієнтам (у кого немає успішних замовлень) замість базових тарифів.',
  day_: 'дні',
  days: 'днів',
  year: 'рік',
  years: 'року',
  years_: 'років',
  pcs: 'шт',
  'osm-hint': 'Безкоштовна карта світу. Використовується в системі за замовчуванням. Підключається без API‑ключа',
  'gomap-hint': 'Безкоштовна національна карта Азербайджану. Підключається без API‑ключа',
  'google-maps-hint': 'Офіційні карти Google Platform. Потрібен API‑ключ, отриманий на сайті сервісу: <a href="https://mapsplatform.google.com/" target="_blank">https://mapsplatform.google.com/</a>',
  'google-maps-api-key-hint': 'Введіть API‑ключ, отриманий на сайті сервісу: <a href="https://mapsplatform.google.com/" target="_blank">https://mapsplatform.google.com/</a>',
  'google-roadmap-hint': 'Режим відображення, що представляє класичну схематичну карту вулиць і доріг',
  'google-hybrid-hint': 'Режим відображення, який поєднує супутникові знімки зі схемою доріг, вулиць і назв об’єктів, накладених поверх них',
  'default-map-hint': 'Виберіть карту, яка відображатиметься вам і вашим користувачам за замовчуванням',
  'Are you sure you want to manually confirm the client\'s email?': 'Ви впевнені, що хочете вручну підтвердити email клієнта?',
  findOrdersPlaceholder: 'Скористайтеся інструментами карти, щоб вказати область пошуку. Виберіть період часу та натисніть "Пошук"',
  'Number of selected objects': 'Кількість вибраних об\'єктів',
  'Command source': 'Джерело команди',
  'Select command source': 'Виберіть джерело команди',
  'Command template': 'Шаблон команди',
  'Payment by card': 'Оплата карткою',
  'Payment by balance': 'Оплата з балансу',
  Compensation: 'Компенсація',
  'Balance adjustment': 'Коригування балансу',
  'Receipts to the client balance': 'Надходження на баланс клієнта',
  'Bonus parking': 'Бонусне паркування',
  'Paid by card': 'Оплачено карткою',
  'Paid by balance': 'Оплачено з балансу',
  'Paid via payment services': 'Платіжні сервіси',
  'Custom period': 'Довільний період',
  'Only my units': 'Тільки мої об\'єкти'
};
